import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { Link, Redirect, withRouter } from "react-router-dom";
import { getNeedHelp, toggleNeedHelp } from "services/user";
import { getFullName } from "utils/displayName";
import {
	getFocusedFolders,
	setFocusedFolders,
	resetFocusedFolders,
	postPhotoFolder,
	deletePhotoFolder,
	validateFolders,
	getFolderByCode,
	changePatient,
	cancelFolder,
	updatePhotoFolder,
	unassignOpenedBy,
	assignOpenedBy,
	getNextFolderToValidate,
	getNextFolderFuture,
	pauseFolderValidation,
	closeBarcodeWarningOpen,
	closeOpenedByWarning,
	updateCommentAndPostit,
	patchGeslabAlert,
	setFamilyLink,
	searchFoldersFamilyLink,
	setPreviousFolder,
	cancelTab,
	postIdentityCheck,
	putEndoAnswers,
	// postMotivations,
} from "services/folder";
import { saveDeposit, removeDeposit, getDepositPlaces, getDepositSamplers } from "services/deposit";
import {
	patchPrescription,
	postPrescription,
	postScanPrescription,
	bulkAnalysesPrescription,
	deletePrescription,
	deleteScanPrescription,
	updateScanPrescription,
	validatePrescription,
	assignSecretary,
	unassignSecretary,
	getPrescriptionByBarcode,
	setSampler,
	getRepeatablePresciptions,
	repeatPresciption,
	setPrescriptionScanBarcode,
	saveResultPrescription,
	getFPA,
	validateScanPrescription,
	validateQualityScanPrescription,
	unvalidateQualityScanPrescription,
	refreshCenterScans,
	cleanScans,
	useScanOrdo,
	removeScanOrdo,
	checkMySecu,
	cleanMySecuCheck,
	getMyLabDocuments,
	getEPrescription,
	checkAnalysis,
	toggleContact,
} from "services/prescription";
import {
	patchPatientFromFolderManager,
	getMatchingPatient,
	patchPatient,
	postPatient,
	getPatientDocuments,
	addPatientDocument,
	deletePatientDocument,
	postPatientMyLab,
	getInvoicesForPatient,
	checkDKVStatus,
	cleanDkvStatus,
	getMpiPatientByMatricule,
} from "services/patient";
import { cancelSafePlaceQR, terminateSafePlaceQR } from "services/safeplace";
import { getDoctorExists, postDoctor, patchDoctor } from "services/doctor";
import { getAnalysisLibrary, getFolderAnalysesCost, getMatchingAnalyses, resetCosts } from "services/analysisLibrary";
import { getGeslabExport } from "services/geslab";
import { patchMultipleTubes, patchTube, addNotPrescribedTube, deleteNotPrescribedTube, getReusableTubes, getMissingVolumeTubes } from "services/tube";
import {
	createFolderHelp,
	abortSupportFolderHelp,
	validateFolderHelp,
	doneFolderHelp,
	postComment,
	getSecretariesActive,
	getFolderHelpCancelReasons,
	sendEmailIncompleteFolder,
} from "services/folderHelp";
import { patchQuestionAnswer } from "services/questionAnswer";
import { getAllAnalysesPack } from "services/analysesPack";
import { Confirm, Container, Grid, Loader, Ref, Responsive, Button, Dimmer, Modal, Tab } from "semantic-ui-react";
import EditPatient from "features/FolderManager/components/SidebarComp/EditPatient";
import EditPrescription from "features/FolderManager/components/SidebarComp/EditPrescription";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import moment from "moment-with-locales-es6";
import WaitButton from "components/Buttons/WaitButton";
import { asyncForEach } from "utils/asyncForEach";
import EditAnalyses from "features/FolderManager/components/SidebarComp/EditAnalyses";
import { toast } from "react-toastify";
import QRReaderPrescriptionModal from "./components/modals/QRReaderPrescriptionModal";
import { ServiceEnum } from "config/service";
import AddRepeatablePrescriptionModal from "./components/modals/AddRepeatablePrescriptionModal";
import isEqual from "lodash.isequal";
import { uniq } from "lodash";
import { getAllTubeAddedReasons, getAllTubeUntakenReasons, getAllTubeNatureReasons } from "services/tubeReason";
import { getAllTubeLibrary } from "services/tubeLibrary";
import { convertForPatientMatcher, convertMyLabToPatient, convertPatientToMyLab } from "utils/patientConverter";
import { errorHandler, ErrorAction } from "utils/error";
import { getAllConsentRefusalReasons } from "services/consentRefusalReason";
import { getPatientHomeAddress } from "utils/address";
import { folderIsPaid, addPayment, folderPaymentCancel, folderPaymentRef } from "services/payment";
import { getAllDocumentTypes } from "services/documentType";
import { getFolderLogs } from "services/log";
import { addAutoScanLogs } from "services/autoScanLog";
import { sendFilesToDualScreen, sendPatientToDualScreen } from "services/dualScreen";
import { getAllValidationPausedReasons } from "services/validationPausedReason";
import ValidationPausedReasonModal from "./components/modals/ValidationPausedReasonModal";
import ContactModal from "./components/modals/ContactModal";
import GranteeModal from "./components/modals/GranteeModal";
import CancelFolderModal from "./components/modals/CancelFolderModal";
import debounce from "debounce-promise";
import CommentNurseHelpModal from "./components/modals/CommentNurseHelpModal";
import { getTimeBetweenInSec } from "utils/dateUtils";
import { b64toFile } from "utils/file";
import { isValidCNS } from "utils/cns";
import { BrowserBarcodeReader } from "@zxing/library";
import { withTranslation } from "react-i18next";
import FolderSection from "./components/Sections/FolderSection";
import PatientSection from "./components/Sections/PatientSection";
import TelesecSection from "./components/Sections/TelesecSection";
import getPanesData from "./components/Tabs";
import TelesecOthersWarningModal from "./components/modals/TelesecOthersWarningModal";
import { isJson } from "utils/json";
import { togglePreregisterWaitingFlag } from "services/preregister";
import DispensationModal from "./components/modals/DispensationModal";
moment.locale("fr");

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

class FolderManager extends Component {
	ref = createRef();

	constructor(props) {
		super(props);
		this.state = {
			data: null,
			tabIndex: 0,
			isInit: true,
			mode: null,
			incrementTakeNumber: false,
			formStatus: true,
			formMotivationStatus: true,
			questionErrors: [],
			motivationsErrors: [],
			abortNurseHelp: false,
			backReturn: false,
			formikRef: null,
			totalCostModal: false,
			openInvoicesModal: false,
			pdfSrc: null,
			secretary: {
				prescriptionsLength: 0,
				countPrescriptionValidated: 0,
				allLoading: false,
				waitingAssignment: false,
				noMorePrescription: false,
			},
			confirmQuitOpen: false,
			confirmNurseValidOpen: false,
			confirmNurseWaitOpen: false,
			confirmNurseQuitOpen: false,
			confirmEmailTelValidOpen: false,
			confirmYoungProche: false,
			confirmProcheNoContact: false,
			confirmCNSInvalid: false,
			confirmPayment: false,
			hasCameraAccess: false,
			QRReaderPrescriptionModal: false,
			addRepeatablePrescriptionModal: false,
			prescriptionIndex: 0,
			confirmCancelFolderOpen: false,
			commentNurseHelpOpen: false,
			addCommentNurseHelp: null,
			natureTubeModal: false,
			userIsSecretary: this.props.user.session.role === "SECRETARY",
			folderOpenedWarningOpen: false,
			unassignOpenedByOnExit: true,
			paymentOptionsModal: false,
			paymentOptionsModalLoading: false,
			confirmPaymentConsentOpen: false,
			validationPausedReasonModalOpen: false,
			contactModalOpen: false,
			contactModalEditPatient: null,
			openScanOrdo: false,
			contactGranteeOpen: false,
			fastResulthasScannedQR: false,
			waitTimer: true,
			openTakePhotoModal: false,
			confirmCancelPaymentOpen: false,
			confirmCancelPaymentId: 0,
			validationLoading: false,
			scansToValidate: false,
			cancelFolder: false,
			historicModalFolderHelp: null,
			addDocsTvSecModalFolderHelp: null,
			confirmFolderHelpOthers: false,
			tvSecMoreInfo: this.props.user.session.role === "SECRETARY",
			cancelFolderWithFolderHelp: false,
			questionsDataToUpdate: [],
			activeTabIndex: "prescriptions",
			identityModalOpen: false,
			selectedCancelReason: null,
			incompleteFolder: false,
			endoStatus: false,
			endoErrors: [],
			showDeposit: false,
			prescriptionToDispense: null,
			dispensationModal: false,
			dkvSyncing: false,
		};
	}
	isFastlinePatient = this.state?.data?.patient?.first_name === "Register" && this.state?.data?.patient?.birth_name === "Line";

	componentDidMount() {
		const path = this.props.location.pathname.split("/");
		if (path[3]) {
			this.props
				.getFolderByCode(path[3])
				.then((res) => {
					this.props.setFocusedFolders([res.payload.data.id]);
					this.openFocusedFolder();
				})
				.catch((error) => {
					// folderErrorReturn(error)
					toast.warn(this.props.t("folderManager.errorLoadingFolder"));
					this.setState({ backReturn: true });
				});
		} else {
			this.openFocusedFolder();
		}
		if (!this.props.documentTypes || !this.props.documentTypes.list || this.props.documentTypes.list.length === 0) this.props.getAllDocumentTypes();

		this.setState({
			scansToValidate:
				this.props.folderManager &&
				this.props.folderManager.folders &&
				this.props.folderManager.folders.length > 0 &&
				this.props.folderManager.folders[0].prescriptions &&
				this.props.folderManager.folders[0].prescriptions.length > 0 &&
				this.props.folderManager.folders[0].prescriptions[0].scans &&
				!!this.props.folderManager.folders[0].prescriptions[0].scans.find((sc) => sc.fromSafeplace && !sc.barcode && !sc.quality_validated),
		});
		this.props.getSecretariesActive();
		this.props.getNeedHelp();
		this.props.getFolderHelpCancelReasons();

		if (this.props.deposit.places.length === 0) this.props.getDepositPlaces();
		if (this.props.deposit.samplers.length === 0) this.props.getDepositSamplers();
	}

	onTabChange = (e, data) => {
		if (this.state.activeTabIndex === "questions" && this.state.formikRef) this.onQuestionsSubmit(this.state.formikRef.getFormikBag().values, true);
		this.setState({ activeTabIndex: data.panes[data.activeIndex]?.menuItem.key });
	};

	toggleTakePhotoModal = () => {
		this.setState((prevState) => ({ ...prevState, openTakePhotoModal: !prevState.openTakePhotoModal }));
	};

	toBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	folderErrorReturn = (err) => {
		toast.warn(this.props.t("folderManager.errorLoadingFolder"));
		this.setState({ backReturn: true });
	};

	hasMissingInformation = (data, confirmNoPay, confirmNoEmailTel, confirmYoungProche, confirmCNSInvalid, confirmProcheNoContact) => {
		if (
			!confirmNoPay &&
			!this.state.confirmPayment &&
			this.isPaymentEnabled() &&
			!this.state.userIsSecretary &&
			!this.props.user.session?.themeHospital &&
			!this.state.showDeposit
		) {
			this.setState({ confirmPayment: true });
			return true;
		}
		if (
			!confirmNoEmailTel &&
			!this.state.confirmEmailTelValidOpen &&
			(!data.patient.mobile_phone || !data.patient.email) &&
			(!data.patient.grantees || data.patient.grantees.length === 0)
		) {
			this.setState({ confirmEmailTelValidOpen: true });
			return true;
		}
		if (
			!confirmYoungProche &&
			!this.state.confirmYoungProche &&
			moment().diff(data.patient.birth_date, "years") < 18 &&
			!data.patient.mobile_phone_is_relative &&
			(!data.patient.grantees || data.patient.grantees.length === 0)
		) {
			this.setState({ confirmYoungProche: true });
			return true;
		}
		if (
			!confirmCNSInvalid &&
			!this.state.confirmCNSInvalid &&
			data.patient.specialRegime &&
			data.patient.specialRegime.geslab_id === "999" &&
			!data.patient.ignoreCnsError &&
			!isValidCNS(data.patient.cns)
		) {
			this.setState({ confirmCNSInvalid: true });
			return true;
		}

		if (
			!confirmProcheNoContact &&
			!this.state.confirmProcheNoContact &&
			moment().diff(data.patient.birth_date, "years") < 18 &&
			data.patient.grantees &&
			data.patient.grantees.length > 0 &&
			data.patient.grantees.filter((g) => g.grantee && !g.grantee.mobile_phone && !g.grantee.email).length > 0
		) {
			this.setState({ confirmProcheNoContact: true });
			return true;
		}

		return false;
	};

	openFocusedFolder = () => {
		if (this.props.folderManager.focusID && this.props.folderManager.focusID.length === 0 && this.props.folderManager.folders.length === 0) {
			this.folderErrorReturn();
			return;
		}

		let isValidateMode = false;

		let focusID = this.props.folderManager.focusID.length > 0 ? this.props.folderManager.focusID : this.props.folderManager.folders.map((f) => f.id);

		if (this.props.logsFolder) {
			focusID = this.props.logsFolder;
		}

		this.props
			.getFocusedFolders(focusID)
			.then((res) => {
				console.log('getFocusedFolders response:', res);
				
				if (!res || !res.payload) {
					console.error('Invalid response: missing payload', res);
					throw new Error('Invalid response structure: missing payload');
				}

				const responseData = res.payload.data;
				console.log('Response data:', responseData);

				if (!responseData) {
					console.error('Invalid response: missing data', res.payload);
					throw new Error('Invalid response structure: missing data');
				}

				setTimeout(() => {
					const state = this.props.folderManager;
					let folders = [];
					let patient = null;

					if (state.data && state.data.folders && Array.isArray(state.data.folders)) {
						folders = state.data.folders;
						patient = state.data.patient || null;
						console.log('Using folders from state:', folders.length);
					} else if (state.folders && Array.isArray(state.folders) && state.folders.length > 0) {
						folders = state.folders;
						patient = state.data?.patient || state.folders[0]?.patient || null;
						console.log('Using folders from state.folders:', folders.length);
					} else if (responseData.folders && Array.isArray(responseData.folders)) {
						folders = responseData.folders;
						patient = responseData.patient || null;
						console.log('Using folders from responseData.folders:', folders.length);
					} else if (Array.isArray(responseData)) {
						folders = responseData;
						patient = responseData[0]?.patient || null;
						console.log('Using folders from responseData array:', folders.length);
					} else if (responseData.id) {
						folders = [responseData];
						patient = responseData.patient || null;
						console.log('Using single folder from responseData:', responseData.id);
					} else {
						console.error('Unexpected response structure:', { responseData, state: state.data });
						throw new Error('Unexpected response structure');
					}

					const firstFolder = folders[0];

					if (!firstFolder) {
						console.error('No folder found', { folders, responseData, state: state.data });
						throw new Error('No folder found in response');
					}

					console.log('Processing folder:', firstFolder.id, 'with patient:', patient?.id);

				if (
					patient &&
					patient.externalIds &&
					Array.isArray(patient.externalIds)
				) {
					const validExternalIds = patient.externalIds.filter((extId) => extId && extId.service);
					const mylabExtId = validExternalIds.find((extId) => extId.service.id === ServiceEnum.mylab);
					if (mylabExtId && mylabExtId.external_id !== 0) {
						this.props.getInvoicesForPatient(mylabExtId.external_id);
					}
				}
				if (this.state.userIsSecretary) {
					if (this.props.folderManager.secretaryMode !== "create") {
						isValidateMode = true;
						this.setState({ mode: "validate" });
						if (firstFolder?.status !== "DONE" || !firstFolder?.json_generated)
							this.props.openSidebar(
								<EditPatient
									patient={patient}
									prescriptions={firstFolder.prescriptions || []}
									onSubmit={this.editPatient}
									hideSidebar={this.props.hideSidebar}
									disabled={false}
									condensedDisplay={true}
									dualScreen={this.props.dualScreen}
									hideOnSubmit={false}
								/>
							);
					} else {
						this.setState({ mode: "edit" });
					}
					if (this.props.dualScreen.presentationConnection && this.props.dualScreen.isAvailable) {
						if (this.props.user.session.center && firstFolder?.status !== "HELP_NURSE")
							this.props.sendPatientToDualScreen(patient);
						else this.props.sendFilesToDualScreen(this.getFullScanList(firstFolder.prescriptions || []));
					}
				} else {
					this.setState({ mode: "sample" });
					this.props.sendPatientToDualScreen(patient);
				}

				const folder = firstFolder;

				if (!folder) {
					console.error('Folder not found');
					return;
				}

				this.props.folderIsPaid(folder.id);

				const openedById = folder.openedBy?.id || folder.opened_by_id || folder.openedById;
				const currentUserId = this.props.user.session.id;
				
				console.log('Checking folder openedBy:', { openedById, currentUserId, openedBy: folder.openedBy });
				
				if (!openedById) {
					this.props.assignOpenedBy(folder.id);
				} else if (Number(openedById) !== Number(currentUserId)) {
					console.log('Folder is opened by another user:', openedById, 'current user:', currentUserId);
					this.setState({ folderOpenedWarningOpen: true });
				}
				if (isValidateMode && folder.prescriptions && !folder.prescriptions[0]?.assigned_secretary && this.state.userIsSecretary) {
					folder.prescriptions.forEach((prescri) => this.props.assignSecretary(prescri));
				}
				if (folder.deposit) {
					this.setShowDeposit(true);
					this.setActiveTabIndex("deposit");
				}
				}, 100);
			})
			.catch((err) => {
				console.error('Error in openFocusedFolder:', err);
				console.error('Error stack:', err.stack);
				this.folderErrorReturn(err);
			});
	};

	setActiveTabIndex = (index) => {
		this.setState({ activeTabIndex: index });
	};

	getFullScanList = (prescriptions) => {
		let scanList = [];
		if (prescriptions && prescriptions.length !== 0) {
			prescriptions.forEach((prescri) => {
				if (prescri.scans && prescri.scans.length > 0) prescri.scans.forEach((scan) => scanList.push(scan));
			});
		}
		return scanList;
	};

	sendFullScanListToDualScreen = () => {
		if (this.props.folderManager.data.folders && this.props.folderManager.data.folders.length > 0) {
			const { prescriptions } = this.props.folderManager.data.folders[0];
			this.props.sendFilesToDualScreen(this.getFullScanList(prescriptions));
		}
	};

	openDispensationModal = (prescription) => {
		this.setState({ dispensationModal: true, prescriptionToDispense: prescription });
	};
	closeDispensationModal = () => {
		this.setState({ dispensationModal: false, prescriptionToDispense: null });
	};

	openValidationPausedReasonModal = () => {
		this.props.getAllValidationPausedReasons();
		this.setState({
			validationPausedReasonModalOpen: true,
		});
	};

	closeValidationPausedReasonModal = () => {
		this.setState({
			validationPausedReasonModalOpen: false,
		});
	};

	componentDidUpdate(prevProps, prevState) {
		if (
			!this.state.backReturn &&
			this.props.folderManager.data &&
			this.props.folderManager.data.folders &&
			this.props.folderManager.data.folders.length > 0 &&
			this.props.folderManager.data.folders[0].prescriptions &&
			this.props.folderManager.data.folders[0].prescriptions.length > 0 &&
			this.props.folderManager.data.folders[0].prescriptions[0].scans &&
			(this.props.folderManager.data.folders[0].prescriptions[0].scans.find((sc) => sc.fromSafeplace && !sc.barcode) === undefined ||
				this.props.folderManager.data.folders[0].prescriptions[0].scans.length === 0) &&
			prevProps.folderManager.data &&
			prevProps.folderManager.data.folders &&
			prevProps.folderManager.data.folders[0].prescriptions &&
			prevProps.folderManager.data.folders[0].prescriptions.length > 0 &&
			prevProps.folderManager.data.folders[0].prescriptions[0].scans &&
			prevProps.folderManager.data.folders[0].prescriptions[0].scans.find((sc) => sc.fromSafeplace && !sc.barcode) !== undefined
		) {
			this.setState({ scansToValidate: true });
		}
		if (this.state.userIsSecretary && this.props.dualScreen?.presentationConnection?.id !== prevProps.dualScreen?.presentationConnection?.id) {
			this.sendFullScanListToDualScreen();
		}
		if (this.props.folderManager.data !== prevProps.folderManager.data) {
			const data = JSON.parse(JSON.stringify(this.props.folderManager.data));
			if (data) {
				if (!this.state.userIsSecretary && data.patient) {
					this.props.sendPatientToDualScreen(data.patient);
				}

				if (data.folders && data.folders.length > 0) {
					this.formatData(data).then((res) => {
						this.setState({ data: res });
						this.checkStatus();
						if (this.props.folderManager.tab > 0) {
							//GO TO RESULT TAB
							this.changeTabIndex(this.props.folderManager.tab);
							this.props.cancelTab();
						}
					});
				}
			}
		}
		if (
			this.state.data &&
			this.state.data.patient &&
			prevState.data &&
			prevState.data.patient &&
			this.state.data.patient.id !== prevState.data.patient.id
		) {
			this.checkDKV(this.state.data.patient);
		}
	}

	componentWillUnmount() {
		if (this.state.unassignOpenedByOnExit) {
			if (this.state.userIsSecretary && this.props.folderManager.data && this.props.folderManager.data.folders) {
				this.props.folderManager.data.folders.forEach((folder) => {
					if (folder.prescriptions && folder.prescriptions.length > 0)
						folder.prescriptions.forEach((presc) => {
							this.props.unassignSecretary(presc);
						});
				});
			}
			if (
				this.props.folderManager &&
				this.props.folderManager.data &&
				this.props.folderManager.data.folders &&
				this.props.folderManager.data.folders.length > 0
			)
				this.props.unassignOpenedBy(this.props.folderManager.data.folders[0].id);
		}
		if (this.state.userIsSecretary) this.props.sendFilesToDualScreen([]);
		this.props.cleanMySecuCheck();
		this.props.cleanDkvStatus();
		if (this.props.user.session.needHelp) this.props.toggleNeedHelp();
		this.props.sendPatientToDualScreen(null);
	}

	changeTabIndex = (index) => {
		const oldIndex = this.state.tabIndex;
		this.setState({ tabIndex: index });
		return oldIndex !== index;
	};

	asyncForEach = async (array, callback) => {
		for (let index = 0; index < array.length; index++) {
			await callback(array[index], index, array);
		}
	};

	createFolderHelpAndQuit = async (folderId, analyzes, other, comment, dataPatient, barcodes, center) => {
		await this.props.createFolderHelp(folderId, analyzes, other, comment, dataPatient, barcodes, center?.id);
		this.props.hideSidebar();
		this.setState({ backReturn: true });
	};

	setFormikRef = (ref) => {
		ref !== this.state.formikRef && this.setState({ formikRef: ref });
	};

	getMaxMinutesAliquots = (center) => {
		if (!center) return 0;
		if (center.aliquotLevel === "MINUS8") return 480;
		if (center.aliquotLevel === "MINUS6") return 360;
		if (center.aliquotLevel === "MINUS4") return 240;
		if (center.aliquotLevel === "MINUS2") return 120;
		return 0;
	};

	hasAliquots = (prescriptions, minutes) => {
		return prescriptions.some(
			(p) =>
				p.analyses &&
				p.analyses.some(
					(a) => a.properties && a.properties.pretreatment_stability <= minutes && a.properties.tubes && a.properties.tubes.some((t) => t.aliquot)
				)
		);
	};
	getPaymentsBySource = () => {
		let partielSum = [];
		this.props.folderManager.paid.payments &&
			this.props.folderManager.paid.payments.forEach((payment) => {
				if (
					partielSum.length > 0 &&
					partielSum.find(
						(ps) => ps.source === payment.source && ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code
					)
				) {
					partielSum.find(
						(ps) => ps.source === payment.source && ps.invoice_reference === payment.invoice_reference && ps.voucher_code === payment.voucher_code
					).price += payment.price;
				} else
					partielSum.push({
						key: payment.key,
						source: payment.source,
						price: payment.price,
						voucher_code: payment.voucher_code,
						invoice_reference: payment.invoice_reference,
					});
			});
		return partielSum;
	};
	setShowDeposit = (show) => {
		this.setState({ showDeposit: show });
	};

	async formatData(data) {
		let finalData = {
			isDone:
				(data.folders[0]?.status === "DONE" && data.folders[0]?.json_generated && this.props.folderManager.secretaryMode === "validate") ||
				(data.folders[0]?.status === "DONE" && this.props.folderManager.secretaryMode !== "validate") ||
				data.folders[0]?.status === "CANCELED" ||
				data.folders[0]?.status === "CANCELEDBYSEC",
			isOpen:
				data.folders[0]?.status === "NEW" ||
				data.folders[0]?.status === "PENDING" ||
				data.folders[0]?.status === "REOPENED" ||
				(data.folders[0]?.status === "HELP_NURSE" && data.folders[0]?.preregister),
			isNurseHelp: data.folders[0]?.status === "HELP_NURSE",
			isHome: data.folders[0]?.appointment !== null ? true : false,
			patient: data.patient,
			prescriptions: [],
			systematic_questions: [],
			questions: [],
			answers: [],
			tubes: [],
			folders: [],
			photos: [],

			infos: {
				tubeStatus: true,
				tubeErrors: [],
				missingVolumeTubes: false,
				prescriptionStatus: true,
				prescriptionErrors: {},
				prescriptionWarnings: {},
				prescriptionOthersWarnings: [],
				waitButton: false,
				takesToGo: 0,
				totalTakes: 1,
				canAddAnalysis: true,
				questionAnswersSaved: true,
				motivationsSaved: true,
				resultStatus: { waiting: [], result: "" },
				safeplace_result: "",
				centerWithAliquots: 0,
				hasAliquots: false,
				aliquotStatus: true,
				aliquotsErrors: [],
				hasIdentityToCheck: false,
				identityCheckStatus: true,
				identityCheckErrors: [],
				identity: {},
			},
			take_number: data.folders[0].take_number,
			costs: {
				totalCosts: { patient: 0, cns: 0, insurance: 0 },
			},
			hasFamilyLink: data.folders[0]?.family_link ? true : false,
			deposit: data.folders[0]?.deposit,
		};

		let newQuestion;
		let existingQuestion;
		let tmpSystematicQuestions = [];
		/**DKV */
		if (
			(!this.props.patients.dkvStatus || this.props.patients.dkvStatus.length === 0) &&
			data.patient &&
			data.patient.patientInsurances?.some((pi) => pi.insurance?.id === 4)
		) {
			this.checkDKV(data.patient);
		}

		/** folders **/
		finalData.folders = await data.folders.map((f) => ({
			code: f.code,
			id: f.id,
			status: f.status,
			isHome: f.labAppointment ? false : true,
			validation_paused: f.validation_paused,
			comment: f.comment,
			geslab_alert: f.geslab_alert,
			geslab_alert_comment: f.geslab_alert_comment,
			geslab_alerts: f.geslab_alerts,
			canceled_reason: f.canceled_reason,
			family_link: f.family_link,
			family_count: f.family_count,
			is_temp: f.is_temp,
			folderHelp: f.folderHelp,
			center: f.labAppointment ? f.labAppointment.center : 0,
			created_at: f.created_at,
			preregister: f.preregister,
			labAppointment: f.labAppointment,
			is_express: f.is_express,
			cb_express: f.express?.barcodes ? JSON.parse(f.express.barcodes) : [],
		}));

		// Prescriptions
		await asyncForEach(data.folders, async (folder) => {
			/** Take Numner **/
			if (folder.take_number <= finalData.take_number) {
				finalData.take_number = folder.take_number;
			}

			/** Photos **/
			await asyncForEach(folder.photos, (photo) => {
				finalData.photos.push(photo);
			});

			/** Prescriptions **/
			if (!folder.prescriptions) return;
			if (folder.prescriptions.length === 0) {
				finalData.infos.prescriptionStatus = false;
				await this.props.getRepeatablePresciptions(data.patient.id);
				if (this.props.prescriptions.repeatable && this.props.prescriptions.repeatable.list && this.props.prescriptions.repeatable.list.length > 0)
					this.setState({ addRepeatablePrescriptionModal: true, isInit: true });
			}

			let tmpQuestions = [];
			finalData.infos.centerWithAliquots = this.getMaxMinutesAliquots(this.props.user.session.center);
			finalData.infos.hasAliquots = this.hasAliquots(folder.prescriptions, finalData.infos.centerWithAliquots);
			finalData.infos.hasIdentityToCheck = folder.prescriptions && Array.isArray(folder.prescriptions) && folder.prescriptions.some((p) => p.analyses && Array.isArray(p.analyses) && p.analyses.some((a) => a.properties && a.properties.identity_check));
			await asyncForEach(folder.prescriptions, async (presc, index) => {
				presc.folderId = folder.id;
				const errors = this.getPrescriptionErrors(presc);
				if (errors.length > 0) {
					finalData.infos.prescriptionErrors[index + 1] = errors;
					finalData.infos.prescriptionStatus = false;
				}

				const warnings = this.getPrescriptionWarnings(presc);
				if (warnings.length > 0) {
					finalData.infos.prescriptionWarnings[index + 1] = warnings;
				}
				const othersWarnings = this.getPrescriptionOthersWarnings(presc);
				if (othersWarnings.length > 0) {
					finalData.infos.prescriptionOthersWarnings = finalData.infos.prescriptionOthersWarnings.concat(othersWarnings);
				}
				if (presc.safeplace_result) finalData.infos.safeplace_result = presc.safeplace_result;

				/** Analyses (in prescription) **/
				finalData.prescriptions.push(presc);

				/** Tubes **/
				await asyncForEach(presc.tubes, (tube) => {
					if (tube && tube.properties && tube.properties.take_number_before_display > finalData.take_number) {
						finalData.infos.waitButton = true;
						finalData.infos.takesToGo =
							tube.properties.take_number_before_display - finalData.take_number >= finalData.infos.takesToGo
								? tube.properties.take_number_before_display - finalData.take_number
								: finalData.take_number;

						finalData.infos.totalTakes =
							tube.properties.take_number_before_display - finalData.infos.totalTakes
								? tube.properties.take_number_before_display
								: finalData.totalTakes;
					}
					if (
						tube.status === "NEW" &&
						tube.properties &&
						tube.properties.take_number_before_display <= finalData.take_number &&
						finalData.infos &&
						finalData.infos.tubeErrors
					) {
						const existingError = finalData.infos.tubeErrors.find((err) => err === tube.properties.label);
						if (!existingError) {
							if (!tube.properties.aliquot) {
								finalData.infos.tubeErrors.push(tube.properties.label);
								finalData.infos.tubeStatus = false;
							} else {
								if (
									finalData.infos.centerWithAliquots > 0 &&
									finalData.infos.hasAliquots &&
									tube.analysis.properties.pretreatment_stability <= finalData.infos.centerWithAliquots
								) {
									finalData.infos.aliquotsErrors.push(tube.properties.label);
									finalData.infos.aliquotStatus = false;
								}
							}
						}
					}
					// if (tube.status !== 'NEW') {
					// 	finalData.infos.canAddAnalysis = false;
					// }
					if (tube && tube.properties && tube.properties.timer_before_result > 0) {
						if (!tube.sampling_time) {
							finalData.infos.resultStatus.waiting.push(this.props.t("folderManager.timerNotStarted"));
						} else {
							if (presc.safeplace_result) finalData.infos.resultStatus.result = presc.safeplace_result;
							else {
								if (getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_results, "m")) > 0)
									finalData.infos.resultStatus.waiting.push(this.props.t("folderManager.timerNotOver"));
								else {
									if (getTimeBetweenInSec(moment(tube.sampling_time).add(tube.properties.timer_before_results, "m")) < -900)
										finalData.infos.resultStatus.waiting.push(this.props.t("folderManager.readingTimeOut"));
									else finalData.infos.resultStatus.waiting.push(this.props.t("folderManager.encodeTestResult"));
								}
							}
						}
					}

					if (tube.id !== undefined && tube.links === undefined) {
						let existingSameTube = finalData.tubes.findIndex((e) => e.properties.id === tube.properties.id && e.added_reason === tube.added_reason);

						if (existingSameTube !== -1) {
							finalData.tubes[existingSameTube].links.push(tube.id);
							if (finalData.tubes[existingSameTube].analyses && finalData.tubes[existingSameTube].analyses.length > 0 && tube.analysis) {
								//Only add the analysis if it doesn't exist
								const analysisExists = finalData.tubes[existingSameTube].analyses.find((ana) => ana.properties?.id === tube.analysis.properties?.id);
								if (!analysisExists) {
									finalData.tubes[existingSameTube].analyses.push(tube.analysis);

									// Tube Alerts
									if (tube.analysis.properties.light_protected) finalData.tubes[existingSameTube].light_protected = true;
									if (tube.analysis.properties.pretreatment_urgent) finalData.tubes[existingSameTube].pretreatment_urgent = true;
								}
							}
						} else {
							tube.links = [tube.id];
							delete tube.id;
							if (tube.analysis && tube.analysis !== null) {
								tube.analyses = [tube.analysis];

								// Tube Alerts
								tube.light_protected = tube.analysis.properties.light_protected;
								tube.pretreatment_urgent = tube.analysis.properties.pretreatment_urgent;
								delete tube.analysis;
							}
							finalData.tubes.push(tube);
						}
					}
				});
				if (!finalData.tubes || finalData.tubes.filter((t) => !t.properties.aliquot).length === 0) {
					finalData.infos.tubeErrors.push(this.props.t("folderManager.noTube"));
					finalData.infos.tubeStatus = false;
				}

				/** Systematic questions **/
				if (
					finalData.prescriptions &&
					finalData.prescriptions.filter((p) => p.analyses && p.analyses.filter((a) => !a.properties.is_covid).length > 0).length > 0
				)
					await asyncForEach(presc.systematic_questions, async (sysQ) => {
						if (!sysQ.value && !sysQ.question.optional_response && (this.state.mode === "sample" || sysQ.question.target === "MIXTE"))
							finalData.infos.questionAnswersSaved = false;

						existingQuestion = tmpSystematicQuestions.find((i) => i.question.id === sysQ.question.id);
						if (existingQuestion) {
							existingQuestion.links.push(sysQ.id);
							if (!existingQuestion.groupName.includes(sysQ.question.group)) {
								existingQuestion.groupName.push(sysQ.question.group);
								existingQuestion.records.concat(
									sysQ.records
										.sort((a, b) => b.id - a.id)
										.map((r) => ({
											...r,
											value: JSON.parse(r.value),
											label: this.formatFieldRecord(r.value),
										}))
								);
							} else {
							}
						} else {
							newQuestion = {
								question: sysQ.question,
								answer_options: sysQ.question.answer_options,
								from_free_input: sysQ.from_free_input,
								records: sysQ.records
									.sort((a, b) => b.id - a.id)
									.map((r) => ({
										...r,
										value: JSON.parse(r.value),
										label: this.formatFieldRecord(r.value),
									})),
								links: [sysQ.id],
								groupName: [sysQ.question.group],
								value: sysQ.value,
								method: sysQ.question.method,
								required: !sysQ.question.optional_response,
							};

							// Handle "autoSelect last record
							newQuestion.value =
								newQuestion.value === null
									? newQuestion.question.auto_select_last_record === "yes" && newQuestion.records.length > 0
										? newQuestion.records[0].value
										: newQuestion.question.auto_select_last_record === "yes-today" &&
										  newQuestion.records.length > 0 &&
										  moment(newQuestion.records[0].created_at).isSame(moment(), "day")
										? newQuestion.records[0].value
										: sysQ.value
									: newQuestion.value;

							tmpSystematicQuestions.push(newQuestion);
						}
					});

				if (finalData.prescriptions && Array.isArray(finalData.prescriptions) && finalData.prescriptions.some((p) => p.analyses && Array.isArray(p.analyses) && p.analyses.some((a) => a.properties && a.properties.code === "ENDO"))) {
					finalData.endoAnswers = data.folders[0]?.endoAnswers || {
						cleanHands: null,
						noInfectionSigns: null,
						noVIH: null,
						noPregnant: null,
						noCancer: null,
						noEating: null,
						noDrinking: null,
						noSmoking: null,
						noChewingGum: null,
						noTeethBrushing: null,
						noLipStick: null,
						conform: null,
					};
				}

				/** Questions
				 * Format :
				 * {
				 *     question: QuestionLibrary,
				 *     answerOptions: AnswerOption[],
				 *     links: questionAnswerID[],
				 *     groupName : string[],
				 *     value: string
				 * }
				 *
				 * **/
				const analyses = presc.analyses;
				// .sort((a, b) =>
				// 	a.properties.code
				// 		.toLowerCase()
				// 		.localeCompare(b.properties.code.toLowerCase())
				// )
				// .sort(
				// 	(a, b) => a.properties.display_order - b.properties.display_order
				// );

				const hasMotivationMarqTumMandatory =
					finalData.prescriptions &&
					finalData.prescriptions.flatMap(
						(p) =>
							p.analyses &&
							p.analyses
								.filter((a) => a.question_answers && Array.isArray(a.question_answers) && a.question_answers.some((q) => q && q.question && q.question.sil_code === "MARQTUM-M01"))
								.reduce((sum, b) => sum + (b.properties?.weight_for_motivation || 0), 0)
					)[0] > 2;
				const hasMotivationPregSeroMandatory =
					finalData.patient &&
					finalData.patient.gender === "f" &&
					finalData.prescriptions &&
					finalData.prescriptions.flatMap(
						(p) =>
							p.analyses &&
							p.analyses
								.filter((a) => a.question_answers && Array.isArray(a.question_answers) && a.question_answers.some((qa) => qa && qa.question && qa.question.code === "MOT-PREGSERO"))
								.reduce((sum, b) => sum + (b.properties?.weight_for_motivation || 0), 0)
					)[0] > 12;

				await asyncForEach(analyses, async (ana) => {
					//motivations

					await asyncForEach(ana.question_answers, (question_answer) => {
						if (
							question_answer.question &&
							question_answer.question.motivation &&
							!question_answer.value &&
							(hasMotivationMarqTumMandatory || question_answer.question.sil_code !== "MARQTUM-M01") &&
							(hasMotivationPregSeroMandatory || question_answer.question.code !== "MOT-PREGSERO") &&
							!question_answer.question.optional_response &&
							(this.state.mode === "sample" || question_answer.question.target === "MIXTE")
						)
							finalData.infos.motivationsSaved = false;
					});
					await asyncForEach(ana.question_answers, (question_answer) => {
						if (
							question_answer.question &&
							!question_answer.question.motivation &&
							!question_answer.value &&
							!question_answer.question.optional_response &&
							(this.state.mode === "sample" || question_answer.question.target === "MIXTE")
						) {
							finalData.infos.questionAnswersSaved = false;
						}

						existingQuestion = tmpQuestions.find((i) => i.question.id === question_answer.question.id);
						if (existingQuestion) {
							existingQuestion.links.push({ id: question_answer.id, weight: ana.properties.weight_for_motivation });
							if (!existingQuestion.groupName.includes(ana.properties.label)) {
								existingQuestion.groupName.push(ana.properties.label);
								existingQuestion.records.concat(
									question_answer.records
										.sort((a, b) => b.id - a.id)
										.map((r) => ({
											...r,
											value: JSON.parse(r.value),
											label: this.formatFieldRecord(r.value),
										}))
								);
							}
						}
						// La question a dÃ©jÃ  Ã©tÃ© ajoutÃ©e
						else {
							// La question n'a pas Ã©tÃ© ajoutÃ©e encore
							newQuestion = {
								question: question_answer.question,
								from_free_input: question_answer.from_free_input,
								answer_options: question_answer.question.answer_options,
								records: question_answer.records
									.sort((a, b) => b.id - a.id)
									.map((r) => ({
										...r,
										value: JSON.parse(r.value),
										label: this.formatFieldRecord(r.value),
									})),
								links: [{ id: question_answer.id, weight: ana.properties.weight_for_motivation }],
								groupName: [ana.properties.label],
								value: question_answer.value,
								method: question_answer.question.method,
								required: !question_answer.question.optional_response,
							};

							newQuestion.value =
								newQuestion.value === null
									? newQuestion.question.auto_select_last_record === "yes" && newQuestion.records.length > 0
										? newQuestion.records[0].value
										: newQuestion.question.auto_select_last_record === "yes-today" &&
										  newQuestion.records.length > 0 &&
										  moment(newQuestion.records[0].created_at).isSame(moment(), "day")
										? newQuestion.records[0].value
										: question_answer.value
									: newQuestion.value;

							tmpQuestions.push(newQuestion);
						}
					});
				});
			});

			/** Mise en forme - Questions object **/
			await asyncForEach(tmpQuestions, (i) => {
				if (Array.isArray(i.groupName)) {
					i.groupName = i.groupName.reduce((a, b) => a + b + " - ", "");
					i.groupName = i.groupName.substr(0, i.groupName.length - 2);
				}
			});

			let index;
			await asyncForEach(tmpQuestions, (i) => {
				index = finalData.questions.findIndex((e) => e.groupName === i.groupName);

				if (index === -1) {
					finalData.questions.push({
						groupName: i.groupName,
						questions: [i],
					});
				} else {
					finalData.questions[index].questions.push(i);
				}
			});

			finalData.questions.sort((a, b) => b.groupName.length - a.groupName.length);
		});

		/** Mise en forme - SystematicQuestions object **/
		await asyncForEach(tmpSystematicQuestions, (i) => {
			if (Array.isArray(i.groupName)) {
				i.groupName = i.groupName.reduce((a, b) => a + b + " - ", "");
				i.groupName = i.groupName.substr(0, i.groupName.length - 2);
			}
		});

		let index2;
		await asyncForEach(tmpSystematicQuestions, (i) => {
			index2 = finalData.systematic_questions.findIndex((e) => e.groupName === i.groupName);

			if (index2 === -1) {
				finalData.systematic_questions.push({
					groupName: i.groupName,
					questions: [i],
				});
			} else {
				finalData.systematic_questions[index2].questions.push(i);
			}
		});

		finalData.systematic_questions.sort((a, b) => b.groupName.length - a.groupName.length);

		const uniqueAnalyses = this.getUniqueAnalyses(finalData.prescriptions);
		const items = uniqueAnalyses.join(",");
		finalData.uniqueAnalyses = items;
		finalData.allAnalysesChecked = !finalData.prescriptions || !Array.isArray(finalData.prescriptions) || !finalData.prescriptions.some((p) => p.analyses && Array.isArray(p.analyses) && p.analyses.some((a) => a.checked_by === null));

		// Before fetching the costs from the api check if the analyses, the prescriber, the billing company, the cns, the motivations or the assurances changed
		const shouldUpdate =
			this.state.data?.uniqueAnalyses !== items ||
			this.state.data?.prescriptions[0]?.no_prescriber !== finalData.prescriptions[0]?.no_prescriber ||
			this.state.data?.prescriptions[0]?.issue_date !== finalData.prescriptions[0]?.issue_date ||
			this.state.data?.prescriptions[0]?.validity_date !== finalData.prescriptions[0]?.validity_date ||
			this.state.data?.prescriptions[0]?.prescriber?.id !== finalData.prescriptions[0]?.prescriber?.id ||
			this.state.data?.prescriptions[0]?.prescriber?.street !== finalData.prescriptions[0]?.prescriber?.street ||
			finalData.prescriptions[0]?.billing_company?.id !== this.state.data?.prescriptions[0]?.billing_company?.id ||
			this.state.data?.patient.cns !== finalData.patient.cns ||
			this.state.data?.patient.specialRegime?.id !== finalData.patient.specialRegime?.id ||
			!isEqual(this.state.data?.patient.patientInsurances, finalData.patient.patientInsurances) ||
			this.state.data?.prescriptions.some(
				(p, i) =>
					p.analyses &&
					p.analyses.some(
						(a, ia) =>
							finalData.prescriptions[i] &&
							finalData.prescriptions[i].analyses[ia] &&
							a.motivation !== finalData.prescriptions[i].analyses[ia].motivation
					)
			);
		if (uniqueAnalyses.length > 0 && shouldUpdate && +finalData?.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE) {
			this.updateCost(finalData, this.calculateCosts);
		} else if (uniqueAnalyses.length === 0) {
			this.props.resetCosts();
		}

		//Only run the first time
		if (!this.state.data) {
			await this.getMissingVolumeTubes(finalData.folders[0].id);
			if (this.props.tubes.missingVolume.list.length > 0) {
				finalData.infos.tubeStatus = false;
				finalData.infos.missingVolumeTubes = true;
			}
		}

		if (
			!this.state.data &&
			this.state.mode === "edit" &&
			data.folders[0]?.status === "HELP_NURSE" &&
			data.folders[0]?.folderHelp &&
			data.folders[0].prescriptions
		) {
			const missingDoc = data.folders[0].prescriptions.flatMap((presc) => presc.scans.filter((s) => s.isDefaultScan));
			await this.getMissingDocsBarcodesWithAutoSearchScan(
				missingDoc && missingDoc.length > 0
					? missingDoc
							.flatMap((d) => d.barcode)
							.concat(
								isJson(data.folders[0].folderHelp.barcodes)
									? JSON.parse(data.folders[0].folderHelp.barcodes)
											.flatMap((c) => c.bc.ordo)
											.concat(JSON.parse(data.folders[0].folderHelp.barcodes).flatMap((c) => c.bc.fpa))
											.concat(JSON.parse(data.folders[0].folderHelp.barcodes).flatMap((c) => c.bc.other.map((o) => o.bc)))
									: data.folders[0].folderHelp.barcodes.split(",")
							)
							.join(",")
					: isJson(data.folders[0].folderHelp.barcodes)
					? JSON.parse(data.folders[0].folderHelp.barcodes)
							.flatMap((c) => c.bc.ordo)
							.concat(JSON.parse(data.folders[0].folderHelp.barcodes).flatMap((c) => c.bc.fpa))
							.concat(JSON.parse(data.folders[0].folderHelp.barcodes).flatMap((c) => c.bc.other?.map((o) => o.bc)))
							.join(",")
					: data.folders[0].folderHelp.barcodes,
				data.folders[0].prescriptions.flatMap((presc) => presc.scans),
				data.folders[0].folderHelp
			);
		}
		if (
			(this.state.mode === "edit" &&
				this.state.isInit &&
				data.folders[0]?.status === "HELP_NURSE" &&
				!!data.folders[0]?.folderHelp &&
				!!data.folders[0].prescriptions &&
				data.folders[0].prescriptions.length > 0 &&
				this.getMissingDocsBarcodes(
					data.folders[0].folderHelp.barcodes,
					data.folders[0].prescriptions.flatMap((presc) => presc.scans)
				)?.length === 0 &&
				!data.folders[0].prescriptions[0].prescriber) ||
			(!this.state.cancelFolder &&
				(this.state.isInit || this.state.scansToValidate || !finalData.infos.prescriptionStatus) &&
				data.folders[0].prescriptions &&
				data.folders[0].prescriptions.length > 0 &&
				data.folders[0].prescriptions[0].safeplace_code &&
				((data.folders[0].prescriptions[0].scans && data.folders[0].prescriptions[0].scans.length > 0) || this.state.scansToValidate))
		) {
			this.setState({
				scansToValidate:
					this.props.folderManager.data &&
					this.props.folderManager.data.folders &&
					this.props.folderManager.data.folders.length > 0 &&
					this.props.folderManager.data.folders[0].prescriptions &&
					this.props.folderManager.data.folders[0].prescriptions.length > 0 &&
					this.props.folderManager.data.folders[0].prescriptions[0].scans &&
					this.props.folderManager.data.folders[0].prescriptions[0].scans.find((sc) => sc.fromSafeplace && !sc.barcode && !sc.quality_validated) !==
						undefined,
			});
			this.props.openSidebar(
				<EditPrescription
					prescription={finalData.prescriptions[0] ?? null}
					onSubmit={finalData.prescriptions?.length > 0 ? this.editPrescription : this.addPrescription}
					openPrescriptionScanModal={() => this.openPrescriptionScanModal(finalData.prescriptions[0])}
					deletePrescription={this.deletePrescription}
					hideSidebar={this.props.hideSidebar}
					hideOnSubmit={true}
					folder={this.props.folderManager.data.folders[0]}
					disabled={finalData.isDone}
					userIsSecretary={this.state.userIsSecretary}
					isSecretaryEditMode={this.state.mode === "edit"}
					patient={this.props.folderManager.data.patient}
					dualScreen={this.props.dualScreen}
					generalParameters={this.props.generalParameters.data}
					showPatientCard={
						this.state.userIsSecretary &&
						this.props.folderManager.data.patient?.id !== +process.env.REACT_APP_USER_TO_CHANGE &&
						!this.isFastlinePatient
					}
					validateScanPrescription={this.validateScanPrescription}
					validateQualityScanPrescription={this.validateQualityScanPrescription}
					unvalidateQualityScanPrescription={this.unvalidateQualityScanPrescription}
					submitBarCode={this.props.setPrescriptionScanBarcode}
					deleteScanPrescription={this.deleteScanPrescription}
					openGranteeModal={this.openGranteeModal}
					openContactModal={this.openContactModal}
					openEditPatient={(prescription) => this.openEditPatient(prescription, finalData.prescriptions, finalData.isDone)}
					validationLoading={this.state.validationLoading}
					scans={this.props.prescriptions.tvSecScans}
					cleanScans={this.props.cleanScans}
					createFolderHelp={this.createFolderHelpAndQuit}
					getAllDocumentTypes={this.props.getAllDocumentTypes}
				/>
			);
		}

		if (!finalData.isDone && this.state.isInit && finalData.prescriptions.length === 0 && data.folders[0]?.status !== "HELP_NURSE") {
			this.props.openSidebar(
				<EditPrescription
					onSubmit={this.addPrescription}
					hideSidebar={this.props.hideSidebar}
					userIsSecretary={this.state.userIsSecretary}
					isSecretaryEditMode={this.state.mode === "edit"}
					disabled={finalData.isDone}
					folder={finalData.folders[0]}
					patient={finalData.patient}
					dualScreen={this.props.dualScreen}
					generalParameters={this.props.generalParameters.data}
					showPatientCard={finalData.patient?.id !== +process.env.REACT_APP_USER_TO_CHANGE && !this.isFastlinePatient}
					openContactModal={this.openContactModal}
					openGranteeModal={this.openGranteeModal}
					openEditPatient={(prescription) => this.openEditPatient(prescription, this.state.data.folders[0].prescriptions, finalData.isDone)}
					validationLoading={this.state.validationLoading}
					scans={this.props.prescriptions.tvSecScans}
					cleanScans={this.props.cleanScans}
					createFolderHelp={this.createFolderHelpAndQuit}
					getAllDocumentTypes={this.props.getAllDocumentTypes}
				/>
			);
		}
		if (finalData.isNurseHelp && finalData.folders[0].folderHelp && finalData.folders[0].folderHelp.other && this.state.isInit) {
			this.setState({ confirmFolderHelpOthers: true });
		}

		if (
			finalData.prescriptions &&
			finalData.prescriptions.length > 0 &&
			finalData.prescriptions[0].mylab_prescription_id > 0 &&
			finalData.prescriptions[0].scans.length === 0 &&
			!this.props.user.session?.themeHospital
		) {
			this.openPrescriptionScanModal(finalData.prescriptions[0]);
		}

		this.setState({ isInit: false });

		return finalData;
	}

	updateCost = async (finalData, calculate) => {
		if (finalData.patient.id === +process.env.REACT_APP_USER_TO_CHANGE) return;
		this.props
			.getFolderAnalysesCost(
				await Promise.all(
					finalData.prescriptions.map(async (presc) => {
						let mysecuCheck = finalData.patient.specialRegime && finalData.patient.cns && new RegExp("^[0-9]{13}$").test(finalData.patient.cns);
						if (
							presc.mysecuChecks &&
							presc.prescriber &&
							presc.prescriber.code &&
							finalData.patient.specialRegime &&
							["11", "2", "3", "999"].includes(finalData.patient.specialRegime.geslab_id) &&
							finalData.patient.cns &&
							new RegExp("^[0-9]{13}$").test(finalData.patient.cns)
						) {
							try {
								let resultCheckMySecu = await this.props.checkMySecu(
									finalData.patient.cns,
									presc.prescriber.code,
									presc.issue_date,
									presc.id,
									finalData.isOpen,
									presc.accident_date,
									presc.accident_number
								);
								if (resultCheckMySecu && resultCheckMySecu.payload && resultCheckMySecu.payload.data && resultCheckMySecu.payload.data.patient)
									mysecuCheck = resultCheckMySecu.payload.data.patient.is_affiliated;
							} catch (e) {
								mysecuCheck = true;
							}
						}
						return {
							items: presc.analyses
								.filter((ana) => ana.properties.catalog_code && ana.properties.calculating_cost)
								.map((ana) => ana.properties.catalog_code)
								.join(","),
							patient_id: finalData.patient.id,
							prescriber_id: presc.prescriber ? presc.prescriber.id : null,
							prescription_date: presc.issue_date ? moment(presc.issue_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
							generate_documents: false,
							isPrescribed: (!!presc.prescriber && !!presc.prescriber.code) || presc.prescriber_to_create_by_secretary,
							bill_company: !!presc.billing_company,
							bill_company_id: presc.billing_company ? presc.billing_company.sil_id : null,
							prescription_id: presc.id,
							checkMySecu:
								finalData.patient.specialRegime && ["11", "2", "3", "999"].includes(finalData.patient.specialRegime.geslab_id) ? mysecuCheck : false,
							expiredPrescription: !moment(presc.validity_date).isSameOrAfter(moment(), "date"), //Ordo périmée (à charge du patient)
							postDatedPrescription: !moment(presc.issue_date).isSameOrBefore(moment(), "date"),
							isOpen: finalData.isOpen,
						};
					})
				)
			)
			.then((res) => {
				calculate();
				return res;
			});
	};

	checkIdentity = (patient, identity) => {
		let errors = [];
		if (identity.birth_date !== patient.birth_date) errors.push("La date de naissance du patanalysisLibrarygetient n'est pas vérifiée");
		if (identity.first_name !== patient.first_name) errors.push("Le prénom du patient n'est pas vérifié");
		if (identity.gender !== patient.gender) errors.push("Le genre du patient n'est pas vérifié");
		if (identity.birth_name !== patient.birth_name) errors.push("Le nom de naissance n'est pas vérifié");
		if (patient.married_name && identity.married_name !== patient.married_name) errors.push("Le nom marital n'est pas vérifié");
		this.setState((prevState) => {
			let data = Object.assign({}, prevState.data);
			data.infos.identityCheckErrors = errors;
			data.infos.identityCheckStatus = errors.length > 0;
			return { data };
		});
		this.props.postIdentityCheck(identity, this.state.data.folders[0].id);
	};

	calculateCosts = () => {
		const { costs, loadingCosts } = this.props.analysisLibrary;
		console.log("calculateCosts", costs);
		if (loadingCosts) return;
		const totalCosts = {
			totalCosts: costs
				.map((c) =>
					c.items?.reduce(
						(totalCosts, costs) => {
							return {
								cns: totalCosts?.cns + costs?.price_state,
								insurance: totalCosts?.insurance + costs?.price_insurance,
								patient: totalCosts?.patient + (costs?.price_patient || 0) + (costs?.price_patient_hn || 0) + (costs?.price_shipping || 0),
							};
						},
						{ cns: 0, insurance: 0, patient: 0 }
					)
				)
				.reduce(
					(total, costs) => {
						return {
							cns: total?.cns + (costs?.cns || 0),
							insurance: total?.insurance + (costs?.insurance || 0),
							patient: total?.patient + (costs?.patient || 0),
						};
					},
					{ cns: 0, insurance: 0, patient: 0 }
				),
		};
		const actsCost = costs
			.filter((c) => c.sampling_acts && !c.bill_company)
			.map((c) => c.sampling_acts?.reduce((totalCosts, act) => (totalCosts += act?.price ?? 0), 0))
			.reduce((partialSum, a) => partialSum + a, 0);

		if (actsCost) totalCosts.totalCosts.patient += actsCost;
		this.setState({ costs: totalCosts });
	};

	getPrescriptionErrors = (presc) => {
		const missingFields = [];
		if (
			(!presc.prescriber && !presc.prescriber_to_create_by_secretary && !presc.no_prescriber) ||
			(!presc.prescriber && this.state.userIsSecretary && this.state.mode !== "edit" && !presc.no_prescriber)
		)
			missingFields.push(this.props.t("folderManager.prescriber"));
		if (!presc.issue_date && !presc.no_prescriber) missingFields.push(this.props.t("folderManager.prescriptionDate"));

		if (presc.accident) {
			if (!presc.accident_number || presc.accident_number.trim() === "") missingFields.push(this.props.t("folderManager.accidentNumber"));
			if (!presc.accident_date || presc.accident_date.trim() === "") missingFields.push(this.props.t("folderManager.accidentDate"));
			if (presc.accident_number && !new RegExp("^(L|U)([0-9]{9})$").test(presc.accident_number.trim()))
				missingFields.push(this.props.t("folderManager.accidentNumberRegex"));
		}
		for (const scans of Object.values(this.groupByDocumentType(presc.scans))) {
			if (scans && scans.entries())
				for (const [index, scan] of scans.entries()) {
					if (!scan.fromSafeplace && (!scan.barcode || scan.barcode === "")) {
						missingFields.push(`Code-barres ${scan.document_type?.title} n°${index + 1}`);
					}
				}
		}
		if (!presc.analyses || presc.analyses.length === 0) missingFields.push(this.props.t("folderManager.noAnalyse"));
		if (presc.scans && presc.scans.find((sc) => sc.fromSafeplace && !sc.validated)) {
			for (const [index, scan] of presc.scans.entries()) {
				if (scan.fromSafeplace && !scan.validated)
					missingFields.push(this.props.t("folderManager.ordoScanNumber") + (index + 1).toString() + this.props.t("folderManager.toValidate"));
			}
		}
		if (presc.scans && presc.scans.find((sc) => sc.fromSafeplace && sc.validated && !sc.to_be_rescan && !sc.barcode && !sc.quality_validated)) {
			for (const [index, scan] of presc.scans.entries()) {
				if (scan.fromSafeplace && scan.validated && !scan.to_be_rescan && !scan.barcode && !scan.quality_validated)
					missingFields.push(this.props.t("folderManager.ordoScanNumber") + (index + 1).toString() + this.props.t("folderManager.qualityToValidate"));
			}
		}
		if (!this.state.userIsSecretary && presc.scans && presc.scans.find((sc) => sc.fromSafeplace && sc.validated && sc.to_be_rescan && !sc.barcode)) {
			for (const [index, scan] of presc.scans.entries()) {
				if (scan.fromSafeplace && scan.validated && scan.to_be_rescan && !scan.barcode)
					missingFields.push(this.props.t("folderManager.ordoNumber") + (index + 1).toString() + this.props.t("folderManager.toRescan"));
			}
		}

		return missingFields;
	};

	checkTreatmentDay = (prop) => {
		switch (moment().day()) {
			case 1:
				return prop.treatment_day_monday;
			case 2:
				return prop.treatment_day_tuesday;
			case 3:
				return prop.treatment_day_wednesday;
			case 4:
				return prop.treatment_day_thursday;
			case 5:
				return prop.treatment_day_friday;
			case 6:
				return prop.treatment_day_saturday;
			case 7:
				return prop.treatment_day_sunday;
			default:
				return false;
		}
	};

	groupByDocumentType = (files) => {
		const grouped = {};
		if (files && files.length > 0)
			for (const file of files) {
				if (grouped[`${file.document_type?.name}`]) grouped[`${file.document_type?.name}`].push(file);
				else grouped[`${file.document_type?.name}`] = [file];
			}
		return grouped;
	};

	getPrescriptionWarnings = (presc) => {
		const missingFields = [];
		if (presc.prescriber && presc.prescriber.mylab_id === null) {
			if (!presc.prescriber?.email || presc.prescriber?.email !== "") missingFields.push(this.props.t("folderManager.prescriberEmail"));
			if (!presc.prescriber?.phone || presc.prescriber?.phone !== "") missingFields.push(this.props.t("folderManager.prescriberPhone"));
			if (!presc.prescriber?.street || presc.prescriber?.street !== "") missingFields.push(this.props.t("folderManager.prescriberStreet"));
			if (!presc.prescriber?.postal_code || presc.prescriber?.postal_code !== "") missingFields.push(this.props.t("folderManager.prescriberZip"));
			if (!presc.prescriber?.country || presc.prescriber?.country !== "") missingFields.push(this.props.t("folderManager.prescriberCountry"));
		}

		return missingFields;
	};

	getPrescriptionOthersWarnings = (presc) => {
		const alerts = [];
		if (!presc.no_prescriber && presc.scans.length === 0 && !this.props.user.session?.themeHospital)
			alerts.push(this.props.t("folderManager.missingScan"));
		if (presc.analyses && presc.analyses.filter((a) => !this.checkTreatmentDay(a.properties)).length > 0) {
			alerts.push(
				this.props.t("folderManager.notToday", {
					notTodayAnalyses: presc.analyses
						.filter((a) => !this.checkTreatmentDay(a.properties))
						.map((a) => a.properties.code)
						.join(", "),
				})
			);
		}
		//if (presc.analyses && presc.analyses.filter((a) => a.properties.pretreatment_stability / 60 < 6 && a.tubes.filter(t => t.properties.aliquot).length > 0).length > 0) {
		if (this.state.userIsSecretary && presc.scans && presc.scans.find((sc) => sc.fromSafeplace && sc.validated && sc.to_be_rescan && !sc.barcode)) {
			for (const [index, scan] of presc.scans.entries()) {
				if (scan.fromSafeplace && scan.validated && scan.to_be_rescan && !scan.barcode)
					alerts.push(this.props.t("folderManager.ordoNumber") + (index + 1).toString() + this.props.t("folderManager.toRescan"));
			}
		}
		return alerts;
	};

	/**
	 *
	 * @param record
	 * Format record value
	 * @returns {*}
	 */
	formatFieldRecord = (record) => {
		if (record !== null && record !== "null") {
			const records = JSON.parse(record);
			if (typeof records === "string") {
				return records;
			} else if (records?.length > 0) {
				let reduce = JSON.parse(record)?.reduce((a, b) => a + b + ", ", "");
				return reduce.substr(0, reduce.length - 2);
			}
		}

		return "";
	};

	/** CHECK FORMS & TUBES **/
	setFormStatus = (status) => {
		this.setState({ formStatus: status });
	};
	setFormMotivationStatus = (status) => {
		this.setState({ formMotivationStatus: status });
	};

	setQuestionErrors = (errors) => {
		this.setState({ questionErrors: errors });
	};

	setMotivationsErrors = (errors) => {
		this.setState({ motivationsErrors: errors });
	};
	setEndoErrors = (errors) => {
		this.setState({ endoErrors: errors });
	};
	setEndoStatus = (status) => {
		this.setState({ endoStatus: status });
	};

	checkfastResultQRCode = (qrcode) => {
		if (this.state.data?.tubes?.filter((t) => t.provider_barcode === qrcode).length > 0) this.setState({ fastResulthasScannedQR: true });
	};

	setNotWaitingTimer = () => {
		this.setState({ waitTimer: false });
	};

	toggleIdentityModal = () => {
		this.setState((prevState) => ({ identityModalOpen: !prevState.identityModalOpen }));
	};

	/*** EDIT FUNCTIONS
	 *
	 * @returns {*}
	 */
	editPatient = async (patient, isFirst = true, openForNurse = false, prescription = null) => {
		if (this.state.userIsSecretary) this.props.showSidebarLoader(true);
		if (patient.doctor) {
			const myLabDoctor = this.props.doctors.list.find((doc) => doc.id === patient.doctor.id);

			if (myLabDoctor) {
				patient.doctor = await this.createOrUpdateDoctor(patient.doctor);
			}
		}

		let insurances = [];
		if (!patient.hasFirstInsurance) patient.patientInsurances = insurances;
		else {
			if (!patient.hasSecondInsurance) {
				if (patient.patientInsurances[0]?.insurance) insurances.push(patient.patientInsurances[0]);
			} else {
				if (patient.patientInsurances[0]?.insurance) insurances.push(patient.patientInsurances[0]);
				if (patient.patientInsurances[1]?.insurance) insurances.push(patient.patientInsurances[1]);
			}
			patient.patientInsurances = insurances;
		}

		await this.props.patchPatientFromFolderManager(patient);
		if (this.state.data?.patient?.id !== patient?.id) {
			this.props.cleanDkvStatus();
			this.checkDKV(patient);
		}
		this.updateCost(this.state.data, this.calculateCosts);
		this.props.sendPatientToDualScreen(patient);
		this.openNextPrescription(isFirst, openForNurse, prescription);
	};

	checkDKV = async (patient) => {
		if (patient && patient.patientInsurances?.some((i) => i.insurance.id === 4)) {
			this.props.checkDKVStatus(patient.id);
		}
	};

	openNextPrescription = async (isFirst = false, openForNurse = false, prescription = null) => {
		if (this.state.userIsSecretary || openForNurse) {
			let shouldOpen = true,
				indexToOpen = 0;
			const { prescriptionIndex } = this.state;
			const { prescriptions } = this.state.data;
			const showPatientCard =
				this.props.folderManager.data.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE &&
				!this.isFastlinePatient &&
				(this.state.userIsSecretary || ((this.state.mode === "edit" || openForNurse) && prescriptions?.length === 0));
			if (!isFirst && prescriptionIndex < prescriptions.length - 1) {
				this.setState({ prescriptionIndex: prescriptionIndex + 1 });
				indexToOpen = prescriptionIndex + 1;
			} else if (!isFirst && prescriptionIndex === prescriptions.length - 1) {
				// If the last prescription is already open, don't open a new one
				shouldOpen = false;
			} else if (this.state.mode === "edit" && prescriptions?.length > 0) {
				// If were are in secretary edit mode and prescriptions exist, don't open a new one
				shouldOpen = false;
			} else if (isFirst) {
				this.setState({ prescriptionIndex: 0 });
			}

			if (shouldOpen) {
				this.props.openSidebar(
					<EditPrescription
						prescription={prescription ?? this.state.data.prescriptions[indexToOpen]}
						onSubmit={prescriptions.length > 0 ? this.editPrescription : this.addPrescription}
						openPrescriptionScanModal={() => this.openPrescriptionScanModal(prescription ?? this.state.data.prescriptions[indexToOpen])}
						deletePrescription={this.deletePrescription}
						hideSidebar={this.props.hideSidebar}
						hideOnSubmit={false}
						folder={this.props.folderManager.data.folders[0]}
						disabled={this.state.data.isDone}
						userIsSecretary={this.state.userIsSecretary}
						isSecretaryEditMode={this.state.mode === "edit"}
						patient={this.props.folderManager.data.patient}
						dualScreen={this.props.dualScreen}
						generalParameters={this.props.generalParameters.data}
						showPatientCard={showPatientCard}
						openGranteeModal={this.openGranteeModal}
						openContactModal={this.openContactModal}
						openEditPatient={
							showPatientCard
								? (prescription) => this.openEditPatient(prescription, this.state.data.folders[0].prescriptions, this.state.data.isDone)
								: null
						}
						validationLoading={this.state.validationLoading}
						validateScanPrescription={this.validateScanPrescription}
						validateQualityScanPrescription={this.validateQualityScanPrescription}
						unvalidateQualityScanPrescription={this.unvalidateQualityScanPrescription}
						deleteScanPrescription={this.deleteScanPrescription}
						scans={this.props.prescriptions.tvSecScans}
						cleanScans={this.props.cleanScans}
						createFolderHelp={this.createFolderHelpAndQuit}
						getAllDocumentTypes={this.props.getAllDocumentTypes}
					/>
				);
			} else this.props.hideSidebar();
			this.props.showSidebarLoader(false);
		}
	};

	editPrescription = async (prescription) => {
		if (this.state.userIsSecretary) this.props.showSidebarLoader(true);

		if (prescription.prescriber && prescription.prescriber.mylab_id)
			prescription.prescriber = await this.createOrUpdateDoctor(prescription.prescriber);

		prescription.carbonCopyDoctors = await Promise.all(
			prescription.carbonCopyDoctors.map(async (ccDoc) => {
				if (ccDoc?.doctor?.mylab_id)
					return {
						...ccDoc,
						doctor: await this.createOrUpdateDoctor(ccDoc.doctor),
					};
				return ccDoc;
			})
		);

		prescription.carbonCopyDoctors = prescription.carbonCopyDoctors.filter((ccDoc) => ccDoc);

		const folderId = prescription.folderId;
		const prescriptionResult = await this.props.patchPrescription(prescription, folderId);

		if (
			prescription.prescriber &&
			prescription.prescriber.code &&
			this.state.data.patient.cns &&
			this.state.data.patient.specialRegime &&
			["1", "11", "2", "3", "4", "5", "6", "7", "999"].includes(this.state.data.patient.specialRegime.geslab_id) &&
			new RegExp("^[0-9]{13}$").test(this.state.data.patient.cns)
		) {
			await this.props.checkMySecu(
				this.state.data.patient.cns,
				prescription.prescriber.code,
				prescription.issue_date,
				prescription.id,
				this.state.data.isOpen,
				prescription.accident_date,
				prescription.accident_number
			);
		}

		if (this.state.userIsSecretary) {
			await this.loadAllAnalysesAndPacks(this.state.data.isHome, this.state.data.folders[0], this.state.data.patient, prescription.prescriber, null);
			this.props.showSidebarLoader(false);
			let indexPresc = this.state.data.prescriptions?.findIndex((p) => p.id === prescription.id) ?? 0;
			this.props.openSidebar(
				<EditAnalyses
					prescription={this.state.data.prescriptions[indexPresc]}
					library={this.props.analysisLibrary}
					onSubmit={this.editAnalyses}
					hideSidebar={this.props.hideSidebar}
					isHome={this.state.data.isHome}
					dualScreen={this.props.dualScreen}
					hideOnSubmit={true}
					center={this.props.center}
					role={this.props.role}
					generalParameters={this.props.generalParameters}
					showAllCatalog={this.props.user.session.center?.showAllCatalog || true}
					createFolderHelp={this.createFolderHelpAndQuit}
					scans={this.props.prescriptions.tvSecScans}
					useScanOrdo={this.props.useScanOrdo}
					removeScanOrdo={this.props.removeScanOrdo}
					cleanScans={this.props.cleanScans}
					loadingScans={this.props.prescriptions.loadingScans}
					folder={this.state.data.folders[0]}
					postScanPrescription={this.postScanPrescription}
					secretaries={this.props.folderHelp.connectedSecretariesList}
					isMobile={isMobile()}
					deleteScanPrescription={this.deleteScanPrescription}
					documentTypes={this.props.documentTypes}
					isDeposit={!!this.state.data.deposit}
					isDomicile={this.props.center === process.env.REACT_APP_DOMICILE_CENTER}
					checkAnalysis={this.props.checkAnalysis}
				/>
			);
		}
		this.updateCost(this.state.data, this.calculateCosts);
		return prescriptionResult;
	};

	loadAllAnalysesAndPacks = async (isHome, folder, patient, prescriber, center) => {
		//let folderId = null;
		//if (folder.status === 'REOPENED') folderId = folder.id;
		await this.props.getAnalysisLibrary(isHome, folder?.id, patient?.id, prescriber?.id, center?.id);
		await this.props.getAllAnalysesPack(isHome, folder.id, prescriber?.id);
	};

	deletePrescription = (prescription) => {
		const folderId = prescription.folderId;
		this.props.deletePrescription(prescription, folderId);
	};

	editAnalyses = async (analysesFactory, prescription, folderId, isNewPrescription = false) => {
		let withTubes = true;

		if (this.state.userIsSecretary || !this.state.data.infos.canAddAnalysis) {
			withTubes = false;
			this.props.showSidebarLoader(true);
		}
		let data = {
			add: uniq(analysesFactory.add.map((a) => a.id)),
			remove: analysesFactory.remove.map((r) => r.id),
			order: analysesFactory.order,
			withTubes: withTubes,
			motivations: analysesFactory.motivations,
		};

		await this.props.bulkAnalysesPrescription(data, prescription, folderId);
		if (!prescription.no_prescriber && prescription.scans.length === 0) {
			this.openPrescriptionScanModal(prescription);
		}
		if (prescription.no_prescriber && prescription.billing_company && prescription.scans.length === 0) {
			this.openPrescriptionScanModal(prescription);
		}
		this.props.showSidebarLoader(false);
	};

	editPostIt = (patient) => {
		this.props.patchPatientFromFolderManager(patient);
	};

	patchTubeSamplingTime = (tube, sampling_time) => {
		if (tube && tube.links && tube.links.length > 0)
			this.props
				.patchMultipleTubes({
					tubes: tube.links,
					status: tube.status,
					sampling_time: sampling_time,
				})
				.catch((err) => {
					errorHandler(this.props.t("folderManager.prelevementHour"), ErrorAction.UPDATE, err);
				});
	};

	submitAddTubeModal = async (values) => {
		const data = {
			folderId: this.state.data.folders[0].id,
			tubeId: values.tube,
			reason: values.added_reason,
		};

		const res = await this.props.addNotPrescribedTube(data);

		const createdTubes = res.payload?.data;
		if (createdTubes && createdTubes.length > 0) {
			const newFormattedTube = {
				...createdTubes[0],
				links: createdTubes.map((tube) => tube.id),
			};
			this.setState((prevState) => {
				let data = Object.assign({}, prevState.data);
				data.tubes.push(newFormattedTube);
				return { data };
			});
		}
	};

	submitDeleteNotPrescribedTubeConfirm = async (tubesToDelete) => {
		const data = {
			tubes: tubesToDelete,
		};

		const res = await this.props.deleteNotPrescribedTube(data);

		const deletedTubes = res.payload.data.tubes;
		let stateTubes = this.state.data.tubes;

		const indexToRemove = stateTubes.findIndex((tube) => isEqual(tube.links, deletedTubes));
		if (indexToRemove !== -1) {
			stateTubes.splice(indexToRemove, 1);
			this.setState((prevState) => {
				let data = Object.assign({}, prevState.data);
				data.tubes = stateTubes;
				return { data };
			});
		}
	};

	patchMultipleTubes = (links, barcode, original, nature_reason) => {
		if (barcode !== "")
			return new Promise((resolve, reject) => {
				let data = {
					tubes: links,
					status: "DONE",
					provider_barcode: barcode,
					sampling_time: new Date(),
					reset: barcode === "",
				};
				if (original !== undefined && original !== null) data["original"] = original;
				if (nature_reason !== undefined) data["nature_reason"] = nature_reason;
				this.props
					.patchMultipleTubes(data)
					.then((res) => {
						if (res.payload && res.payload.data) {
							if (res.payload.data.success) {
								if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0)
									this.state.data.prescriptions.forEach((presc) => {
										if (!presc.sampler) this.props.setSampler(presc);
									});
								this.setState({ incrementTakeNumber: true });
							}
							resolve(res.payload.data);
						}
					})
					.catch((err) => reject(err));
			});
		return new Promise((resolve, reject) => {
			let data = {
				tubes: links,
				status: "NEW",
				provider_barcode: null,
				sampling_time: null,
				reset: barcode === "",
			};
			if (original !== undefined && original !== null) data["original"] = original;
			if (nature_reason !== undefined) data["nature_reason"] = nature_reason;
			this.props
				.patchMultipleTubes(data)
				.then((res) => {
					if (res.payload && res.payload.data) {
						if (res.payload.data.success) {
							if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0)
								this.state.data.prescriptions.forEach((presc) => {
									if (!presc.sampler) this.props.setSampler(presc);
								});

							this.setState({ incrementTakeNumber: true });
						}
						resolve(res.payload.data);
					}
				})
				.catch((err) => reject(err));
		});
	};

	patchTubeNature = async (tubeLinks, nature_reason) => {
		return new Promise((resolve, reject) => {
			this.props
				.patchMultipleTubes({
					tubes: tubeLinks,
					nature_reason: nature_reason,
				})
				.then((res) => {
					if (res.payload && res.payload.data) {
						resolve(res.payload.data);
					}
				})
				.catch((err) => reject(err));
		});
	};

	patchUntakenTube = async (tubeLinks, untaken_reason) => {
		return new Promise((resolve, reject) => {
			this.props
				.patchMultipleTubes({
					tubes: tubeLinks,
					status: untaken_reason ? "UNTAKEN" : "NEW",
					untaken_reason: untaken_reason,
					reset: true,
				})
				.then((res) => {
					if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0)
						this.state.data.prescriptions.forEach((presc) => {
							if (!presc.sampler) this.props.setSampler(presc);
						});
					if (res && res.payload && res.payload.data) resolve(res.payload.data);
				})
				.catch((err) => reject(err));
		});
	};

	cancelReuseTube = (links) => {
		return new Promise((resolve, reject) => {
			this.props
				.patchMultipleTubes({
					tubes: links,
					status: "NEW",
					provider_barcode: null,
					sampling_time: null,
					original: true,
					reset: true,
				})
				.then((res) => {
					if (res && res.payload && res.payload.data && res.payload.data.success) {
						resolve();
					}
					reject();
				})
				.catch((err) => reject(err));
		});
	};

	patchTube = (tube) => {
		this.props.patchTube(tube);
	};

	prevalidFolders = () => {
		if (this.state.formikRef)
			this.state.formikRef
				.getFormikBag()
				.validateForm()
				.then((res) => {
					if (res.isCanceled === true) {
						return false;
					} else {
						let newStatus = res.isCanceled === undefined && Object.entries(res).length === 0 && res.constructor === Object;
						this.setFormStatus(newStatus);
					}
				});
	};

	getQuestions = (questions) => {
		const formatedQuestions = [];
		if (questions)
			questions.forEach((q) => {
				if (q.questions && q.questions.some((q) => !q.question.motivation))
					q.questions.forEach((qInfo) => {
						if (!qInfo.motivation) formatedQuestions.push(qInfo.question);
					});
			});
		return formatedQuestions;
	};

	getQuestionsWithErrors = (questions, errors) => {
		const questionsWithErrors = [];
		const idWithErrors = Object.keys(errors).map((key) => key);
		if (questions && idWithErrors.length > 0)
			questions.forEach((question) => {
				if (idWithErrors.includes(question.id.toString())) questionsWithErrors.push(question.label);
			});
		return questionsWithErrors;
	};

	getMotivations = (questions) => {
		const motivationQuestions = [];
		if (questions)
			questions.forEach((q) => {
				if (q.questions && q.questions.some((q) => q.question.motivation))
					q.questions.forEach((qInfo) => {
						if (qInfo.motivation) motivationQuestions.push(qInfo.question);
					});
			});
		return motivationQuestions;
	};

	getMotivationsWithErrors = (questions, errors) => {
		const motivationsWithErrors = [];
		const idWithErrors = Object.keys(errors).map((key) => key);
		if (questions && idWithErrors.length > 0)
			questions.forEach((question) => {
				if (idWithErrors.includes(question.id.toString())) motivationsWithErrors.push(question.label);
			});
		return motivationsWithErrors;
	};

	checkStatus = () => {
		if (this.state.data && this.state.data.endoAnswers) {
			this.setEndoStatus(
				Object.values(this.state.data.endoAnswers).length > 0 && !Object.values(this.state.data.endoAnswers).some((i) => i === false || i === null)
			);
			this.setEndoErrors(
				Object.values(this.state.data.endoAnswers).filter((i) => i === false || i === null).length === 0
					? []
					: Object.keys(this.state.data.endoAnswers)
							.filter((i) => this.state.data.endoAnswers[i] === false || this.state.data.endoAnswers[i] === null)
							.map((i) => i)
			);
		} else {
			this.setEndoStatus(true);
		}
		if (this.state.formikRef) {
			this.state.formikRef
				.getFormikBag()
				.validateForm()
				.then((resValid) => {
					if (resValid.isCanceled === true) {
						return false;
					} else {
						const formatedQuestions = [...this.getQuestions(this.state.data.systematic_questions), ...this.getQuestions(this.state.data.questions)];
						this.setQuestionErrors(this.getQuestionsWithErrors(formatedQuestions, resValid));
						const formatedMotivations = [...this.getMotivations(this.state.data.questions)];
						this.setMotivationsErrors(this.getMotivationsWithErrors(formatedMotivations, resValid));
						this.setState({
							formStatus: Object.entries(resValid).length === 0 && resValid.constructor === Object,
						});
						this.setFormStatus(this.state.formStatus);
					}
				});
		}
	};

	openConfirmationModal = (type) => {
		if (this.state.formikRef)
			this.state.formikRef
				.getFormikBag()
				.validateForm()
				.then((res) => {
					if (res.isCanceled === true) {
						return false;
					} else {
						let newStatus = res.isCanceled === undefined && Object.entries(res).length === 0 && res.constructor === Object;

						if (newStatus === false) {
							this.setFormStatus(newStatus);
							return false;
						} else {
							if (type === "valid") {
								this.setState({ conf: true });
							} else {
								this.setState({ confirmNurseWaitOpen: true });
							}
						}
					}
				});
	};

	/** VALIDATE FOLDERS **/
	validateFolders = async () => {
		let dataToSend = {
			foldersID: this.state.data.folders.map((i) => i.id),
			incrementTakeNumber: true,
		};

		await this.props.validateFolders(dataToSend.foldersID, true, this.props.centers?.center?.id).then(() => {
			this.setState({ backReturn: true });
		});
	};

	validateAndExportFolder = async (confirmNoPay, confirmNoEmailTel, confirmYoungProche, confirmCNSInvalid, confirmProcheNoContact) => {
		const { data } = this.state;
		/* 		console.log("validateAndExportFolder", data);
		if (data.prescriptions.some((p) => !!p.agence_prescription_id)) {
			let epnId = data.prescriptions.find((p) => !!p.agence_prescription_id).agence_prescription_id;
			let response = await this.props.getEPrescription(epnId);
			console.log("epn", response?.payload?.data);
			this.openDispensationModal(response?.payload?.data);
		} */
		if (!this.hasMissingInformation(data, confirmNoPay, confirmNoEmailTel, confirmYoungProche, confirmCNSInvalid, confirmProcheNoContact)) {
			this.validateFolders()
				.then(async () => {
					if (data.prescriptions && data.prescriptions.length > 0 && data.prescriptions[0].safeplace_code)
						this.props.terminateSafePlaceQR(this.state.data.prescriptions[0].safeplace_code, this.props.centers?.center.id);
					this.props.setPreviousFolder(data.folders[0]?.family_link?.id ?? data.folders[0].id);
					if (this.props.generalParameters.data.disableFolderSecondValidation) await this.props.getGeslabExport(data.folders[0].id);
				})
				.catch((e) => {
					toast.error("Erreur lors de la validation du dossier => dossier non exporté");
					console.log("Erreur lors de la validation du dossier => dossier non exporté", data.folders[0].id, e);
				});
			return true;
		}
		return false;
	};

	putEndoAnswers = async (data) => {
		const { id } = this.state.data.folders[0];
		this.setEndoStatus(!Object.values(data).some((i) => i === false));
		this.setEndoErrors(
			Object.values(data).filter((i) => i === false).length === 0
				? []
				: Object.keys(data)
						.filter((i) => data[i] === false)
						.map((i) => i)
		);
		await this.props.putEndoAnswers(data, id);
	};

	/* 	refuseAnalysis = async (analysisId) => {
		await this.props.refuseAnalysis(analysisId);
	}; */

	/** ScanPrescriptionModal**/
	openPrescriptionScanModal = (prescription) => {
		this.props.getAllDocumentTypes().then(() => this.setState({ openScanOrdo: { id: prescription.id } }));
	};

	postScanPrescription = async (data, data_back, barcode, prescriptionId, folderId, documentTypeId, qualityValidated = false) => {
		let formData = new FormData();
		formData.append("scan", data);
		if (data_back) formData.append("scan_back", data_back);
		formData.append("barcode", barcode);
		formData.append("document_type", documentTypeId);
		formData.append("quality_validated", qualityValidated);
		const res = await this.props.postScanPrescription(formData, prescriptionId, folderId);
		if (this.state.userIsSecretary) this.sendFullScanListToDualScreen();

		return res;
	};

	deleteScanPrescription = async (prescriptionScan, prescriptionId, folderId) => {
		folderId = folderId ?? this.state.data.folders[0].id;
		prescriptionId = prescriptionId ?? this.state.data.prescriptions.find((p) => p.scans.map((s) => s.id).includes(prescriptionScan.id))?.id;
		await this.props.deleteScanPrescription(prescriptionScan, prescriptionId, folderId);
		if (this.state.userIsSecretary) this.sendFullScanListToDualScreen();
		this.setState({ isInit: true });
	};

	updateScanPrescription = async (prescriptionScanId, prescriptionId, oldPrescriptionId, folderId) => {
		folderId = folderId ?? this.state.data.folders[0].id;
		oldPrescriptionId = oldPrescriptionId ?? this.state.data.prescriptions.find((p) => p.scans.map((s) => s.id).includes(prescriptionScanId))?.id;
		await this.props.updateScanPrescription(prescriptionScanId, prescriptionId, oldPrescriptionId, folderId);
		if (this.state.userIsSecretary) this.sendFullScanListToDualScreen();
		this.setState({ isInit: true });
	};

	validateScanPrescription = async (prescriptionScan) => {
		let folderId = this.state.data.folders[0].id;
		let prescriptionId = this.state.data.prescriptions.find((p) => p.scans.map((s) => s.id).includes(prescriptionScan.id))?.id;
		await this.props.validateScanPrescription(prescriptionScan, prescriptionId, folderId);
	};

	validateQualityScanPrescription = async (prescriptionScan) => {
		let folderId = this.state.data.folders[0].id;
		let prescriptionId = this.state.data.prescriptions.find((p) => p.scans.map((s) => s.id).includes(prescriptionScan.id))?.id;
		await this.props.validateQualityScanPrescription(prescriptionScan, prescriptionId, folderId);
	};

	unvalidateQualityScanPrescription = async (prescriptionScan) => {
		let folderId = this.state.data.folders[0].id;
		let prescriptionId = this.state.data.prescriptions.find((p) => p.scans.map((s) => s.id).includes(prescriptionScan.id))?.id;
		await this.props.unvalidateQualityScanPrescription(prescriptionScan, prescriptionId, folderId);
	};

	setQuestionsDataToUpdate = (data) => this.setState({ questionsDataToUpdate: data });

	onMotivationsSubmit = (_values, silentMode) => {
		let patchData = {
			patient: this.state.data.patient.id,
			answers: _values,
			silentMode: silentMode,
		};
		this.props.postMotivations(patchData, this.state.data.folders[0].id, silentMode);
	};

	onQuestionsSubmit = (_values, silentMode) => {
		this.checkStatus();
		const values = Object.keys(_values)
			.slice(0)
			.reduce((result, key) => {
				result[key] = _values[key];

				return result;
			}, {});
		let finalData = this.state.questionsDataToUpdate.map((d) => {
			d.from_free_input = false;

			// Gestion du free input added
			if (d.has_free_input && (values[d.id] === "freeInput" || values[d.id].includes("freeInput"))) {
				// Cas particulier du checkbox, on doit ajouter en manuel la valeur du freeInput dans l'array
				if (d.method === "checkbox") {
					let l = values[d.id].slice();
					let index = l.findIndex((i) => i === "freeInput");
					l.splice(index, 1, values[d.id + "freeInput"]);
					d.value = l;
				} else {
					if (Array.isArray(values[d.id + "freeInput"])) d.value = values[d.id + "freeInput"];
					else d.value = values[d.id + "freeInput"];
				}

				d.from_free_input = true;
			} else if (values[d.id] === "") {
				d.value = null;
			} else if (!Array.isArray(values[d.id])) {
				d.value = [values[d.id]];
			} else {
				d.value = values[d.id];
			}

			return d;
		});

		let patchData = {
			patient: this.state.data.patient.id,
			answers: finalData,
			silentMode: silentMode,
		};

		this.props
			.patchQuestionAnswer(patchData)
			.then(async (r) => {
				await this.updateCost(this.state.data, this.calculateCosts);
			})
			.catch((e) => {
				console.log("Erreur rencontrée à la sauvegarde d'une question", e);
				toast.warn(this.props.t("folderManager.errorAskSave"));
			});
	};

	/** FolderPhoto **/
	postPhotoFolder = (photo, barcode, documentTypeId, keepName = false) => {
		let formData = new FormData();
		formData.append("photo", photo);
		formData.append("barcode", barcode || "");
		formData.append("keep_name", keepName);
		formData.append("document_type", documentTypeId);

		// Take first folder by default
		this.props.postPhotoFolder(formData, this.state.data.folders[0].id);
	};

	updateFolderPhoto = (photoId, comment, barcode) => {
		this.props.updatePhotoFolder(this.state.data.folders[0].id, photoId, comment, barcode);
	};

	deletePhoto = (id) => {
		this.props.deletePhotoFolder(id);
	};

	/*** ADD FUNCTIONS
	 *
	 * @returns {*}
	 */
	addPrescription = async (values, tvsec = false) => {
		this.setState({ validationLoading: true });
		if (this.state.data) values.patient = this.state.data.patient.id;

		if (values.prescriber?.mylab_id) {
			values.prescriber = await this.createOrUpdateDoctor(values.prescriber);
		}

		values.carbonCopyDoctors = await Promise.all(
			values.carbonCopyDoctors?.map(async (ccDoc) => {
				if (ccDoc?.doctor?.mylab_id)
					return {
						...ccDoc,
						doctor: await this.createOrUpdateDoctor(ccDoc.doctor),
					};
				return ccDoc;
			})
		);

		//Remove all null elements
		values.carbonCopyDoctors = values.carbonCopyDoctors.filter((notNull) => notNull);

		values.folder = this.state.data.folders[0].id;
		const prescription = this.props.postPrescription(values).then(async (res) => {
			if (
				values.prescriber &&
				this.state.data.patient.cns &&
				new RegExp("^[0-9]{13}$").test(this.state.data.patient.cns) &&
				this.state.data.patient.specialRegime &&
				["1", "11", "2", "3", "4", "5", "6", "7", "999"].includes(this.state.data.patient.specialRegime.geslab_id)
			) {
				await this.props.checkMySecu(
					this.state.data.patient.cns,
					values.prescriber.code,
					values.issue_date,
					res.payload.data.id,
					this.state.data.isOpen,
					values.accident_date,
					values.accident_number
				);
			}
			await this.loadAllAnalysesAndPacks(
				this.state.data.isHome,
				this.state.data.folders[0],
				this.state.data.patient,
				values.prescriber,
				this.props.user.session.center
			);
			this.setState({ validationLoading: false });
			if (res.payload) {
				if (!tvsec)
					this.props.openSidebar(
						<EditAnalyses
							prescription={res.payload.data}
							library={this.props.analysisLibrary}
							onSubmit={(analysesFactory, prescription, folderId) => this.editAnalyses(analysesFactory, prescription, folderId, true)}
							hideSidebar={this.props.hideSidebar}
							isHome={this.state.data.isHome}
							dualScreen={this.props.dualScreen}
							showAllCatalog={this.props.user.session.center?.showAllCatalog || true}
							createFolderHelp={this.createFolderHelpAndQuit}
							scans={this.props.prescriptions.tvSecScans}
							useScanOrdo={this.props.useScanOrdo}
							removeScanOrdo={this.props.removeScanOrdo}
							cleanScans={this.props.cleanScans}
							loadingScans={this.props.prescriptions.loadingScans}
							folder={this.state.data.folders[0]}
							center={this.props.user.session.center}
							role={this.props.user.session.role}
							generalParameters={this.props.generalParameters.data}
							postScanPrescription={this.postScanPrescription}
							secretaries={this.props.folderHelp.connectedSecretariesList}
							isMobile={isMobile()}
							deleteScanPrescription={this.deleteScanPrescription}
							documentTypes={this.props.documentTypes}
							isDeposit={!!this.state.data.deposit}
							isDomicile={this.props.center === process.env.REACT_APP_DOMICILE_CENTER}
							checkAnalysis={this.props.checkAnalysis}
						/>
					);
			} else toast.warn(this.props.t("folderManager.errorPrescriptionCreate"));
			return res.payload.data;
		});
		return prescription;
	};

	/** SECRETARY FUNCTIONS **/
	unassignSecretary = async () => {
		await asyncForEach(this.props.folderManager.data.folders, async (folder) => {
			await asyncForEach(folder.prescriptions, (presc) => {
				this.props.unassignSecretary(presc);
			});
		});

		this.props.resetFocusedFolders();
	};

	validatePrescription = () => {
		if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0)
			this.state.data.prescriptions.forEach((presc) => {
				this.props.validatePrescription(presc);
			});
	};

	saveSafeplaceResult = (result) => {
		if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0)
			this.state.data.prescriptions.forEach((presc) => {
				this.props.saveResultPrescription(presc, result);
			});
	};

	validatePrescriptionAndNext = async () => {
		this.setState({
			...this.state,
			tabIndex: 0,
			secretary: {
				allLoading: true,
				prescriptionsLength: this.state.data.prescriptions.length,
				waitingAssignment: false,
				countPrescriptionValidated: 0,
			},
		});

		let i = 0;

		await asyncForEach(this.state.data.prescriptions, async (presc) => {
			await this.props.validatePrescription(presc);
			await this.props.unassignSecretary(presc);

			this.setState({
				...this.state,
				secretary: {
					...this.state.secretary,
					countPrescriptionValidated: i + 1,
				},
			});
		});

		this.setState({
			...this.state,
			secretary: { allLoading: true, waitingAssignment: true },
		});

		if (this.props.folderManager.secretaryMode === "validate") {
			this.props.getGeslabExport(this.props.folderManager.data.folders[0].id);
			this.props.getNextFolderToValidate(this.state.data.folders[0].validation_paused).then(async (response) => {
				if (!response.payload.data || !response.payload.data.id) {
					this.setState({
						...this.state,
						secretary: { noMorePrescription: true },
					});
				} else {
					this.props.setFocusedFolders([response.payload.data.id]);
					await this.props
						.getFocusedFolders([response.payload.data.id])
						.then((res) => {
							this.props.sendFilesToDualScreen(this.getFullScanList(res.payload.data.folders[0].prescriptions));
							this.props.openSidebar(
								<EditPatient
									patient={res.payload.data.patient}
									prescriptions={res.payload.data.folders[0].prescriptions}
									onSubmit={this.editPatient}
									hideSidebar={this.props.hideSidebar}
									disabled={this.state.data.isDone}
									condensedDisplay={true}
									dualScreen={this.props.dualScreen}
								/>
							);
						})
						.catch((err) => {
							this.folderErrorReturn(err);
						});
					if (response.payload.data && response.payload.data.prescriptions && response.payload.data.prescriptions.length > 0)
						response.payload.data.prescriptions.forEach((prescri) => this.props.assignSecretary(prescri));
					this.props.assignOpenedBy(response.payload.data.id);

					this.setState({
						...this.state,
						secretary: {
							allLoading: false,
							prescriptionsLength: 0,
							waitingAssignment: false,
							countPrescriptionValidated: 0,
						},
					});
				}
			});
		} else if (this.props.folderManager.secretaryMode === "future") {
			this.props.getNextFolderFuture().then((response) => {
				if (!response.payload.data || !response.payload.data.id) {
					this.setState({
						...this.state,
						secretary: { noMorePrescription: true },
					});
				} else {
					this.props.setFocusedFolders([response.payload.data.id]);
					this.props
						.getFocusedFolders([response.payload.data.id])
						.then((res) => {
							this.props.openSidebar(
								<EditPatient
									patient={res.payload.data.patient}
									prescriptions={res.payload.data.folders[0].prescriptions}
									onSubmit={this.editPatient}
									hideSidebar={this.props.hideSidebar}
									disabled={this.state.data.isDone}
									condensedDisplay={true}
									dualScreen={this.props.dualScreen}
								/>
							);
						})
						.catch((err) => {
							this.folderErrorReturn(err);
						});
					if (response.payload.data && response.payload.data.prescriptions && response.payload.data.prescriptions.length > 0)
						response.payload.data.prescriptions.forEach((prescri) => this.props.assignSecretary(prescri));
					this.props.assignOpenedBy(response.payload.data.id);

					this.setState({
						...this.state,
						secretary: {
							allLoading: false,
							prescriptionsLength: 0,
							waitingAssignment: false,
							countPrescriptionValidated: 0,
						},
					});
				}
			});
		}
	};

	pauseFolderValidationAndNext = async (reason) => {
		this.setState({
			secretary: {
				allLoading: true,
				waitingAssignment: true,
			},
		});
		await this.props.pauseFolderValidation(this.state.data.folders[0].id, reason);
		this.props.getNextFolderToValidate(this.state.data.folders[0].validation_paused).then(async (response) => {
			if (!response.payload.data || !response.payload.data.id) {
				this.setState({
					...this.state,
					secretary: { noMorePrescription: true },
				});
			} else {
				this.props.setFocusedFolders([response.payload.data.id]);
				await this.props
					.getFocusedFolders([response.payload.data.id])
					.then((res) => {
						this.props.sendFilesToDualScreen(this.getFullScanList(res.payload.data.folders[0].prescriptions));
						this.props.openSidebar(
							<EditPatient
								patient={res.payload.data.patient}
								prescriptions={res.payload.data.folders[0].prescriptions}
								onSubmit={this.editPatient}
								hideSidebar={this.props.hideSidebar}
								disabled={this.state.data.isDone}
								condensedDisplay={true}
								dualScreen={this.props.dualScreen}
							/>
						);
					})
					.catch((err) => {
						this.folderErrorReturn(err);
					});
				if (response.payload.data && response.payload.data.prescriptions && response.payload.data.prescriptions.length > 0)
					response.payload.data.prescriptions.forEach((prescri) => this.props.assignSecretary(prescri));
				if (response.payload && response.payload.data) this.props.assignOpenedBy(response.payload.data.id);
				this.setState({
					secretary: {
						allLoading: false,
						waitingAssignment: false,
					},
				});
			}
		});
	};

	closeInvoicesModal = () => {
		this.setState({ openInvoicesModal: false });
	};

	openTotalCostModal = async () => {
		if (this.props.logsFolder) {
			await this.props.folderIsPaid(this.props.logsFolder[0]);
		} else {
			await this.props.folderIsPaid(this.props.folderManager.focusID[0]);
		}
		this.setState({ totalCostModal: true });
	};
	openInvoicesModal = async () => {
		if (this.props.logsFolder) {
			await this.props.folderIsPaid(this.props.logsFolder[0]);
		} else {
			await this.props.folderIsPaid(this.props.folderManager.focusID[0]);
		}
		this.setState({ openInvoicesModal: true });
	};

	openPaymentOptionsModal = () => {
		this.setState({ paymentOptionsModal: true });
	};

	closePaymentOptionsModal = () => {
		this.setState({ paymentOptionsModal: false, paymentOptionsModalLoading: false });
	};

	closeQRReaderPrescriptionModal = () => {
		this.setState({ QRReaderPrescriptionModal: false });
	};

	openQRReaderPrescriptionModal = () => {
		const scanAvailableState = {
			hasCameraAccess: true,
			QRReaderPrescriptionModal: true,
		};
		this.setState(scanAvailableState);
	};

	createOrUpdateDoctor = async (myLabDoctor) => {
		const localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
		// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
		// @see reducers/doctor.js
		await this.props.getDoctorExists(localDoctor.mylab_id);
		//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
		// The MYLAB doctor does not exist on NURSE
		if (this.props.doctors.exists === 0) {
			localDoctor.id = null; // Make sure it is null
			// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
			// @see reducers/doctor.js
			await this.props.postDoctor(localDoctor);
			// With possible failure
			if (this.props.doctors.doctor) localDoctor.id = this.props.doctors.doctor.id;
		} else {
			localDoctor.id = this.props.doctors.exists;
			await this.props.patchDoctor(localDoctor);
			/* console.warn(
				"[NURSE-341#2589] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
				localDoctor
			); */
		}
		return localDoctor;
	};

	createPrescription = async (scannedData, patient, doctor, folderId, mylabPrescriptionId = null, copyDoctors = [], agencePrescriptionId = null) => {
		const prescription = scannedData;
		prescription.id = null;
		prescription.accident = !!prescription.accident_number;
		prescription.reason = "";
		prescription.patient = patient.id;
		prescription.folder = folderId;
		prescription.prescriber = doctor.id;
		prescription.provider_barcode = prescription.reference;
		prescription.reference = null;
		prescription.issue_date = prescription.date;
		prescription.show_mylab = true;
		prescription.notification_mylab = true;
		prescription.mylab_prescription_id = mylabPrescriptionId ? +mylabPrescriptionId : null;
		prescription.agence_prescription_id = agencePrescriptionId;
		prescription.copyDoctors = copyDoctors;

		const prescriptionResult = await this.props.postPrescription(prescription);
		if (prescriptionResult.error) {
			errorHandler(this.props.t("folderManager.prescription"), ErrorAction.CREATE, prescriptionResult.error);
			return null;
		}
		prescription.id = prescriptionResult.payload.data.id;
		return prescription;
	};

	submitQRReaderPrescriptionModal = async (values) => {
		const prescriptionId = values.split(/_/).pop();
		const folderId = this.props.folderManager.data.folders[0].id;

		const scanResult = await this.props.getPrescriptionByBarcode(prescriptionId);
		if (!scanResult.payload || !scanResult.payload.data) toast.warn(this.props.t("folderManager.noPrescriptionReturned"));
		if (scanResult.payload.data.patient.externalIds[0].external_id !== this.props.patients.exists.externalIds[0].external_id)
			toast.warn(this.props.t("folderManager.eprescriptionIncorectPatient"));
		else {
			const scannedData = scanResult.payload.data.result;
			if (!scannedData.id) {
				toast.warn(this.props.t("folderManager.unableAddPrescription"));
			} else {
				//Doctor
				const myLabDoctor = scannedData.medical_staff_data;
				myLabDoctor.mylab_id = scannedData.issuer_id;
				myLabDoctor.code = myLabDoctor.provider_code;
				// Not in returned data
				myLabDoctor.sil_id = myLabDoctor.external_id;
				const localDoctor = await this.createOrUpdateDoctor(myLabDoctor);

				let copyDoctors = [];
				if (scannedData.copy_to_medical_staff && scannedData.copy_to_medical_staff.length > 0) {
					scannedData.copy_to_medical_staff.map(async (doctor) => {
						doctor.mylab_id = doctor.id;
						copyDoctors.push({ doctor: await this.createOrUpdateDoctor(doctor) });
					});
				}

				//Prescription
				const prescription = await this.createPrescription(scannedData, this.state.data.patient, localDoctor, folderId, prescriptionId, copyDoctors);

				if (prescription) {
					const catalogCodes = scannedData.items.map((a) => a.analysis_reference).join(",");
					await this.props.getMatchingAnalyses(catalogCodes, false);
					const { matchingIdList, resultMatching } = this.props.analysisLibrary;
					//Analyses
					const analysesData = {
						add: matchingIdList,
						remove: [],
						withTubes: true,
					};
					await this.props.bulkAnalysesPrescription(analysesData, prescription, folderId);
					if (resultMatching && resultMatching.analyzesMissing && resultMatching.analyzesMissing.length > 0) {
						toast.warn(this.props.t("folderManager.warningAnalyse"));
					}
					if (!prescription.no_prescriber && !this.state.data.isNurseHelp) this.openPrescriptionScanModal(prescription);
				}
			}
		}
	};

	openAddRepeatablePrescriptionModal = async () => {
		await this.props.getRepeatablePresciptions(this.state.data.patient.id);
		this.setState({ addRepeatablePrescriptionModal: true });
	};

	closeAddRepeatablePrescriptionModal = (withoutRepeatablePrescription = true) => {
		if (!withoutRepeatablePrescription) this.props.hideSidebar();
		this.setState({ addRepeatablePrescriptionModal: false });
	};

	submitAddRepeatablePrescriptionModal = async (values) => {
		const folderId = this.props.folderManager.data.folders[0].id;

		await this.props.repeatPresciption(values.prescription, folderId);
	};

	loadAddTubeModalData = () => {
		this.props.getAllTubeLibrary();
		this.props.getAllTubeAddedReasons();
	};

	submitChangePatientModal = (patient) => {
		if (patient.mylabId !== 0) {
			this.updateOrCreateLocalPatient(patient).then((newPatientId) => {
				this.props.changePatient(this.state.data.folders[0].id, newPatientId);
			});
		} else {
			const myLabPatient = convertPatientToMyLab(patient);
			this.props.postPatientMyLab(myLabPatient).then((res) => {
				if (res.payload && res.payload.data && res.payload.data.id && res.payload.status.toString().startsWith("20")) {
					patient.mylab_id = res.payload.data.id;
					patient.mylab_is_active = res.payload.data.active;
					this.props.postPatient(patient).then((res) => {
						this.props.changePatient(this.state.data.folders[0].id, res.payload.data.id);
					});
				} else {
					toast.error("Impossible de créer le patient dans MyLab.");
				}
			});
		}

		if (!this.isFastlinePatient) {
			this.props.openSidebar(
				<EditPrescription
					prescription={this.state.data.prescriptions[0] ?? null}
					onSubmit={this.state.data.prescriptions?.length > 0 ? this.editPrescription : this.addPrescription}
					openPrescriptionScanModal={() => this.openPrescriptionScanModal(this.state.data.prescriptions[0])}
					deletePrescription={this.deletePrescription}
					hideSidebar={this.props.hideSidebar}
					hideOnSubmit={true}
					folder={this.props.folderManager.data.folders[0]}
					disabled={this.state.data.isDone}
					userIsSecretary={this.state.userIsSecretary}
					isSecretaryEditMode={this.state.mode === "edit"}
					patient={this.props.folderManager.data.patient}
					dualScreen={this.props.dualScreen}
					generalParameters={this.props.generalParameters.data}
					showPatientCard={false}
					validateScanPrescription={this.validateScanPrescription}
					validateQualityScanPrescription={this.validateQualityScanPrescription}
					unvalidateQualityScanPrescription={this.unvalidateQualityScanPrescription}
					submitBarCode={this.props.setPrescriptionScanBarcode}
					deleteScanPrescription={this.deleteScanPrescription}
					openGranteeModal={this.openGranteeModal}
					openContactModal={this.openContactModal}
					openEditPatient={(prescription) => this.openEditPatient(prescription, this.state.data.prescriptions, this.state.data.isDone)}
					validationLoading={this.state.validationLoading}
					scans={this.props.prescriptions.tvSecScans}
					cleanScans={this.props.cleanScans}
					createFolderHelp={this.createFolderHelpAndQuit}
					getAllDocumentTypes={this.props.getAllDocumentTypes}
				/>
			);
		}
	};

	openConfirmCancelFolder = () => {
		this.setState({ confirmCancelFolderOpen: true });
	};

	closeConfirmCancelFolder = () => {
		this.setState({ confirmCancelFolderOpen: false });
	};

	openCommentNurseHelp = () => {
		this.setState({ commentNurseHelpOpen: true });
	};

	closeCommentNurseHelp = () => {
		if (this.state.addCommentNurseHelp) this.setState({ addCommentNurseHelp: null, selectedCancelReason: null });
		this.setState({ commentNurseHelpOpen: false, cancelFolderWithFolderHelp: false, incompleteFolder: false });
	};

	submitConfirmCancelFolder = async (canceled_reason, comment) => {
		await this.props.cancelFolder(this.state.data.folders[0].id, canceled_reason, comment);
		this.setState({ cancelFolder: true });
		if (this.state.data.prescriptions && this.state.data.prescriptions.length > 0 && this.state.data.prescriptions[0].safeplace_code)
			await this.props.cancelSafePlaceQR(this.state.data.prescriptions[0].safeplace_code, this.props.centers?.center.id);
		this.props.setPreviousFolder(this.state.data.folders[0]?.family_link?.id ?? this.state.data.folders[0].id);
		this.setState({
			confirmCancelFolderOpen: false,
			backReturn: true,
		});
	};

	submitCommentNurseHelp = async (abort, cancelReason, comment, incompleteFolder) => {
		try {
			if (this.state.data.folders[0].preregister && incompleteFolder)
				this.props.sendEmailIncompleteFolder(cancelReason, comment, this.state.data.folders[0].preregister.id);
			if (abort)
				await this.props.abortSupportFolderHelp(
					this.state.data.folders[0].id,
					this.props
						.t(
							incompleteFolder
								? "folderManager.emailPatientIncompleteFolder"
								: this.state.cancelFolderWithFolderHelp
								? "folderManager.cancelFolderAndSupport"
								: "folderManager.cancelSupport"
						)

						.concat(this.props.folderHelp.cancelReasons.filter((cr) => cr.id === cancelReason)[0].label)
						.concat(comment ? ` : ${comment}` : ""),
					this.state.cancelFolderWithFolderHelp,
					cancelReason
				);
			else await this.props.validateFolderHelp(this.state.data.folders[0].id, comment);
			if (this.state.cancelFolderWithFolderHelp) this.submitConfirmCancelFolder(cancelReason, comment);
			this.setState({
				confirmCancelFolderOpen: false,
				backReturn: true,
				cancelFolderWithFolderHelp: false,
			});
			this.props.sendPatientToDualScreen(null);
		} catch (e) {
			console.log("error submitCommentNurseHelp ", e);
		}
	};

	updateOrCreateLocalPatient = async (myLabPatient) => {
		await this.props.getMatchingPatient(ServiceEnum.mylab, myLabPatient.id ?? 0, convertForPatientMatcher(myLabPatient));
		const { exists } = this.props.patients;
		myLabPatient = { ...myLabPatient, externalIds: exists?.externalIds };
		const localPatient = convertMyLabToPatient(myLabPatient);
		if (!exists) {
			localPatient.id = null;
			const postPatientResponse = await this.props.postPatient(localPatient);
			if (postPatientResponse.payload.data) localPatient.id = postPatientResponse.payload.data.id;
		} else {
			localPatient.id = exists.id;
			if (!moment(localPatient.updated_at).isBefore(moment(exists.updated_at))) {
				await this.props.patchPatientFromFolderManager(localPatient);
			}
		}
		return localPatient.id;
	};

	getReusableTubes = () => {
		const { data } = this.state;
		this.props.getReusableTubes(data.patient.id, {
			tubes: data.tubes
				.map((tube) => {
					if (tube.analyses)
						return {
							tube: tube.properties.id,
							analysisIds: tube.analyses.map((ana) => ana.properties.id),
						};
					else return null;
				})
				.filter((item) => item !== null),
		});
	};

	getMissingVolumeTubes = async (folderId) => {
		await this.props.getMissingVolumeTubes(folderId || this.state.data.folders[0].id);
	};
	hasTubeWithResults = (tubes) => {
		return tubes ? tubes.some((t) => t.properties.timer_before_result > 0) : false;
	};
	tubeWithTimerBeforeResult = (tubes) => {
		if (this.hasTubeWithResults(tubes)) return tubes.filter((t) => t.properties.timer_before_result > 0)[0];
	};

	imageOnloadAutoScan = (image, onFinally) => {
		let barcode = "";
		const codeReader = new BrowserBarcodeReader();
		codeReader
			.decodeFromImage(image)
			.then((result) => {
				if (!result) toast.warn(this.props.t("folderManager.anyBarCodeFound"));
				else barcode = result.text;
			})
			.catch((err) => {
				console.error("imageOnloadAutoScan error", err);
			})
			.finally(() => onFinally(barcode));
	};

	getPatientDocuments = () => {
		this.props.getPatientDocuments(this.state.data.patient.id);
	};

	postPatientDocument = (document, documentTypeId) => {
		let formData = new FormData();
		formData.append("document", document);
		formData.append("document_type", documentTypeId);

		this.props.addPatientDocument(this.state.data.patient.id, formData);
	};

	newPatient = async (values) => {
		// @see NURSE-341 `doctors.list` is populated at reducer stage with existing MYLAB doctors from NURSE database
		// @see reducers/doctor.js
		const myLabDoctor = this.props.doctors.list.find((doc) => doc.id === values.doctor.id);
		if (myLabDoctor) {
			// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
			// @see reducers/doctor.js
			await this.props.getDoctorExists(myLabDoctor.id);
			const localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
			localDoctor.mylab_id = localDoctor.id;
			localDoctor.sil_id = myLabDoctor.external_id;
			//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
			// The MYLAB doctor does not exist on NURSE
			if (this.props.doctors.exists === 0) {
				localDoctor.id = null; // Make sure it is null
				// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
				// @see reducers/doctor.js
				await this.props.postDoctor(localDoctor);
				// With possible failure
				if (this.props.doctors.doctor) values.doctor.id = this.props.doctors.doctor.id;
			} else {
				localDoctor.id = this.props.doctors.exists;
				//await this.props.patchDoctor(localDoctor);
				console.warn(
					"[NURSE-341#2900] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
					localDoctor
				);
				values.doctor.id = localDoctor.id;
			}
		}
		const myLabPatient = convertPatientToMyLab(values);
		this.props.postPatientMyLab(myLabPatient).then((res) => {
			if (res.payload && res.payload.data && res.payload.data.id && res.payload.status.toString().startsWith("20")) {
				values.mylab_id = res.payload.data.id;
				values.mylab_is_active = res.payload.data.active;
				this.props.postPatient(values).then((res) => {
					this.props.changePatient(this.state.data.folders[0].id, res.payload.data.id);
					this.props.hideSidebar();
				});
			} else {
				toast.error("Impossible de créer le patient dans myLab.");
			}
		});
	};

	postCommentFolderHelp = async (folderHelpId, comment) => {
		this.props.postComment(folderHelpId, comment).then((res) => {
			let { folderManager } = this.props;
			if (res.payload && res.payload.data) {
				this.setState((prevState) => {
					let data = Object.assign({}, prevState.data);
					data.folders[0].folderHelp = folderManager.data.folders[0].folderHelp;
					return { data };
				});
			}
		});
	};

	isPaymentPaidWithoutStripe = () => {
		let { costs } = this.state;
		let { folderManager } = this.props;
		return (
			folderManager.paid.payments.length > 0 &&
			!folderManager.paid.payments.find((p) => p.source === "stripe") &&
			!folderManager.paid.payments.find((p) => p.source === "voucher") &&
			costs?.totalCosts?.patient > 0
		);
	};
	isNotPaid = () => {
		return this.amountToPay() > 0;
	};

	amountToPay = () => {
		let { costs } = this.state;
		return (costs?.totalCosts?.patient.toFixed(2) - this.currentAmountAlreadyPaid()).toFixed(2);
	};

	getPaymentPartition = () => {
		const { costs } = this.props.analysisLibrary;
		let cost = costs.map((c) => {
			let costAnalysis = c.items?.reduce(
				(totalCosts, costs) => totalCosts + costs?.price_patient + (costs?.price_patient_hn || 0) + (costs?.price_shipping || 0),
				0
			);
			let costActs = c.sampling_acts && !c.bill_company ? c.sampling_acts?.reduce((totalCosts, act) => (totalCosts += act?.price ?? 0), 0) : 0;
			return {
				prescription: c.prescription_id,
				cost: ((costAnalysis ? costAnalysis : 0) + (costActs ? costActs : 0)).toFixed(2),
			};
		});
		return cost;
	};
	amoutAlreadyPaid = () => {
		let { folderManager } = this.props;
		if (folderManager.paid.payments && folderManager.paid.payments.length > 0)
			return folderManager.paid.payments.reduce((accum, p) => accum + p.price, 0).toFixed(2);
		return 0;
	};
	currentAmountAlreadyPaid = () => {
		let { folderManager } = this.props;
		if (folderManager.paid.payments && folderManager.paid.payments.length > 0)
			return folderManager.paid.payments
				.filter((p) => !p.invoice_reference)
				.reduce((accum, p) => accum + p.price, 0)
				.toFixed(2);
		return 0;
	};

	isPaymentEnabled = () => {
		let { data, costs } = this.state;
		return data.infos.prescriptionStatus && !data.isDone && this.amountToPay() > 0 && costs?.totalCosts?.patient > 0;
	};

	getUniqueAnalyses = (prescriptions) => {
		let uniqueAnalyses = prescriptions
			.filter((p) => p.analyses)
			.map((presc) => {
				return presc.analyses.map((ana) => ana.properties.catalog_code);
			});
		uniqueAnalyses = [].concat.apply([], uniqueAnalyses);
		uniqueAnalyses = Array.from(new Set(uniqueAnalyses));
		return uniqueAnalyses;
	};

	blueCardColor = (isUrgent, prescriptions) => {
		let isLuxairAnalyse =
			prescriptions &&
			prescriptions.filter(
				(presc) => presc.analyses && presc.analyses.filter((ana) => ana.properties.sil_code === process.env.REACT_APP_LUXAIR_CODE_CATALOG).length > 0
			).length > 0;
		let isQCovAnalyse =
			prescriptions &&
			prescriptions.filter(
				(presc) => presc.analyses && presc.analyses.filter((ana) => ana.properties.sil_code === process.env.REACT_APP_QCOV_CODE_CATALOG).length > 0
			).length > 0;
		const { data, costs } = this.state;
		let displayPatientCostColor = false;
		if (!isUrgent) {
			const patientCostAnalyses = process.env.REACT_APP_ANALYSES_COVID.split(" ");
			const uniqueAnalyses = this.getUniqueAnalyses(data.prescriptions);

			displayPatientCostColor =
				uniqueAnalyses.findIndex((ana) => patientCostAnalyses.includes(ana)) > -1 && costs?.totalCosts?.patient.toFixed(2) > 0;
		}

		return {
			backgroundColor: isQCovAnalyse
				? "#FF007C"
				: isLuxairAnalyse
				? "#8900e4"
				: isUrgent
				? "#ff504d"
				: displayPatientCostColor
				? "#f1c40f"
				: "#0074e4",
			border: isQCovAnalyse
				? "1px solid #FF007C"
				: isLuxairAnalyse
				? "1px solid #8900e4"
				: isUrgent
				? "1px solid #ff504d"
				: displayPatientCostColor
				? "1px solid #f1c40f"
				: "1px solid #0074e4",
		};
	};

	openGranteeModal = (patient) =>
		this.setState({
			contactGranteeOpen: true,
		});

	closeGranteeModal = (patient) =>
		this.setState({
			contactGranteeOpen: false,
		});

	openContactModal = (editPatient) =>
		this.setState({
			contactModalOpen: true,
			contactModalEditPatient: editPatient,
		});

	openEditPatient = (prescription, prescriptions, isDone) => {
		this.props.openSidebar(
			<EditPatient
				patient={this.state.data.patient}
				prescriptions={prescriptions}
				onSubmit={(patient) => {
					this.editPatient(patient, true, true, prescription);
				}}
				hideSidebar={this.props.hideSidebar}
				disabled={isDone}
				dualScreen={this.props.dualScreen}
			/>
		);
	};
	closeContactModal = () =>
		this.setState({
			contactModalOpen: false,
			contactModalEditPatient: null,
		});

	filterFamilyLink = debounce((searchTerm) => {
		return new Promise((resolve, reject) => {
			this.props
				.searchFoldersFamilyLink(this.props.user.session.center.id, this.state.data.folders[0].id, searchTerm)
				.then(() => {
					resolve(
						this.props.folderManager.foldersFamilyLink.map((folder) => ({
							value: folder.id,
							label: this.props.t("folderManager.folder") + folder.code + " - " + getFullName(folder.patient),
						}))
					);
				})
				.catch((error) => {
					reject(error);
				});
		});
	}, 500);

	getScansForTVsecretariat = (searchInCenter, barcodes = [], clean = false, centerId = this.props.user.session.center.id) => {
		if (clean) return new Promise(() => this.props.cleanScans());
		const barcode = isJson(barcodes)
			? JSON.parse(barcodes)
					.flatMap((c) => c.bc.ordo)
					.concat(JSON.parse(barcodes).flatMap((c) => c.bc.fpa))
					.concat(JSON.parse(barcodes).flatMap((c) => c.bc.other))
					.join("::")
			: barcodes && barcodes.length > 0 && !searchInCenter
			? barcodes.join("::")
			: null;
		if (centerId)
			this.props.refreshCenterScans(centerId, barcode).then(async (res) => {
				if (barcodes && barcodes.length > 0 && res.payload.data.scans && res.payload.data.scans.length > 0) {
					let matching = res.payload.data.scans.reduce((acc, item) => {
						if (barcodes && barcodes.length > 0)
							barcodes.forEach((bc) => {
								if (
									item.barcodes &&
									item.barcodes
										.split("-")
										.map((element) => element.trim())
										.includes(bc)
								)
									acc.push({ ...item, bcMatched: bc });
							});
						return acc;
					}, []);

					if (matching && matching.length > 0) {
						let { data } = this.state;
						let prescription =
							data.prescriptions && data.prescriptions.length > 0
								? data.prescriptions[0]
								: await this.addPrescription(
										{
											patient: data.patient,
											folder: data.folders[0].id,
											carbonCopyDoctors: [],
											urgent: false,
											to_be_faxed: false,
											to_be_phoned: false,
											accident: false,
											reason: "",
										},
										true
								  );
						matching.forEach(async (match) => {
							await this.addScanOrdoToPrescription(match, prescription);
						});
						return new Promise(() => this.props.cleanScans());
					}
				}
			});
	};

	addScanOrdoToPrescription = async (scan, prescription) => {
		let { data } = this.state;
		if (!prescription)
			prescription = await this.addPrescription(
				{
					patient: data.patient,
					folder: data.folders[0].id,
					carbonCopyDoctors: [],
					urgent: false,
					to_be_faxed: false,
					to_be_phoned: false,
					accident: false,
					reason: "",
				},
				true
			);
		await this.postScanPrescription(
			b64toFile(scan.rectoBase64, scan.format, 512, "scans-ordo.jpg"),
			scan.versoBase64 ? b64toFile(scan.versoBase64, scan.format, 512, "scans-ordo_back.jpg") : "",
			scan.bcMatched ?? scan.barcodes,
			prescription.id,
			data.folders[0].id,
			1,
			true
		);
		await this.props.useScanOrdo(scan.id, prescription.id);
	};

	getMissingDocsBarcodes = (barcodes, docs) => {
		let result = [];
		if (barcodes && barcodes !== "")
			try {
				if (isJson(barcodes)) {
					result = JSON.parse(barcodes)
						.flatMap((b) => b.bc.ordo)
						.filter(
							(bc) =>
								!docs
									.filter((d) => !d.isDefaultScan)
									.map((d) => d.barcode)
									.includes(bc)
						);
				} else if (barcodes)
					result = barcodes.split(",").filter(
						(bc) =>
							!docs
								.filter((d) => !d.isDefaultScan)
								.map((d) => d.barcode)
								.includes(bc)
					);
				//else result = JSON.parse(barcodes);
			} catch (e) {
				console.log("erreur getMissingDocsBarcodes", e, barcodes);
			}
		return result;
	};
	getMissingDocsBarcodesWithAutoSearchScan = async (barcodes, docs, folderHelp) => {
		let missingDocs = this.getMissingDocsBarcodes(barcodes, docs);
		if (missingDocs && missingDocs.length > 0) {
			await this.getScansForTVsecretariat(false, missingDocs, false, folderHelp.id);
		}
		return missingDocs;
	};

	getTvSecStatus = (folderHelp) => {
		if (folderHelp)
			switch (folderHelp.status) {
				case "NEW":
					return "En attente";
				case "SUPPORT":
					return `Vous traitez ce dossier`;
				case "REASSIGNED":
					return "Prêt";
				case "DONE":
					return "Terminé";
				case "ASSIGNED":
					return `Ce dossier vous est assigné`;
				case "PENDING":
					return "En attente d'un.e secrétaire senior";
				case "CANCELED":
				case "CANCELEDBYSEC":
					return "Annulé";
				default:
					break;
			}
	};

	selectCustomStyles = {
		container: (provided) => ({
			...provided,
			paddingTop: 5,
			width: "100%",
			cursor: "pointer",
		}),
		option: (provided) => ({
			...provided,
			cursor: "pointer",
			color: "black",
		}),
		control: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
	};

	getDepositErrors = (deposit) => {
		const { t } = this.props;
		if (!deposit) return [];
		let errors = [];
		if (deposit.prel_place === null) {
			errors.push(t("subMenu.depositMissingPrelPlace"));
		} else {
			if (deposit.prel_place?.requireTypeDomicile && (deposit.domicile === "NOT_MENTIONED" || deposit.domicile === null)) {
				errors.push(t("subMenu.depositMissingDomicile"));
			}
			if (deposit.prel_place?.requireTypeDomicile && (deposit.rdv === "NOT_MENTIONED" || deposit.rdv === null)) {
				errors.push(t("subMenu.depositMissingRdv"));
			}
			if (!deposit.prel_place.numSeqNotRequiredForDeposit && (deposit.numSeq === "" || deposit.numSeq === null)) {
				errors.push(t("subMenu.depositMissingNumSeq"));
			}
			if (!deposit.prel_place.numSeqNotRequiredForDeposit && (deposit.numSeq.length !== 8 || !deposit.numSeq.match(new RegExp("^[0-9]{8}$")))) {
				errors.push(t("subMenu.depositCompleteNumSeq"));
			}
		}
		if (deposit.prel_date === null) {
			errors.push(t("subMenu.depositMissingPrelDate"));
		}
		if (deposit.sampler === null) {
			errors.push(t("subMenu.depositMissingSampler"));
		}
		return errors;
	};

	render = () => {
		let {
			data,
			mode,
			formStatus,
			backReturn,
			questionErrors,
			costs,
			userIsSecretary,
			motivationsErrors,
			formMotivationStatus,
			endoErrors,
			endoStatus,
		} = this.state;
		let { generalParameters, folderManager, analysisLibrary, validationPausedReasons, t } = this.props;
		let { role } = this.props.user.session;
		let secretaryVariables = this.state.secretary;
		let isThemeHospital = this.props.user.session?.themeHospital;
		if (backReturn) {
			return <Redirect to="/home/lab" />;
		}
		if (data === undefined || data === null) {
			return <Loader active />;
		} else if (secretaryVariables.allLoading) {
			return (
				<div style={{ width: "100%", textAlign: "center", marginTop: "3em" }}>
					<Loader active />
					{!secretaryVariables.waitingAssignment && (
						<div style={{ marginTop: "1em", fontSize: "0.9em", fontWeight: 600 }}>
							{t("folderManager.prescriptionValidation")}
							<br />
							{secretaryVariables.countPrescriptionValidated} / {secretaryVariables.prescriptionsLength}
						</div>
					)}
					{secretaryVariables.waitingAssignment && (
						<div style={{ marginTop: "1em", fontSize: "0.9em" }}>{t("folderManager.newFolderRetrieving")}</div>
					)}
				</div>
			);
		} else if (secretaryVariables.noMorePrescription) {
			return (
				<div style={{ width: "100%", textAlign: "center", marginTop: "3em" }}>
					<div
						style={{
							marginTop: "1em",
							fontSize: "0.9em",
							fontWeight: 600,
							color: "#545b03",
						}}
					>
						{t("folderManager.moreValidationPrescription")}
						<br />
						<br />
						<Link to={"/home/lab"}>
							<SecondaryButton text="Menu principal" />
						</Link>
					</div>
				</div>
			);
		} else {
			const patientAddress = getPatientHomeAddress(data.patient);
			const isUrgent = data.prescriptions.findIndex((prescri) => prescri.urgent) > -1;

			return (
				<Container style={{ paddingTop: 28 }}>
					<Ref innerref={this.ref}>
						<div>
							{(folderManager.analysisLoading || analysisLibrary.loading || folderManager.loading) && (
								<Dimmer active>
									<Loader />
								</Dimmer>
							)}
							<TelesecOthersWarningModal
								folder={data.folders[0]}
								confirmFolderHelpOthers={this.state.confirmFolderHelpOthers}
								close={() => this.setState({ confirmFolderHelpOthers: false })}
							/>

							<Grid>
								<Grid.Row style={{ paddingTop: 0, marginBottom: 10 }}>
									<Grid.Column
										style={{
											paddingRight: 0,
											paddingLeft: 0,
											justifyContent: "space-between",
											display: "flex",
											flexDirection: mode === "validate" && data.isDone ? "row" : "row-reverse",
											flex: 1,
										}}
									>
										{mode !== "validate" && (
											<>
												{mode === "sample" &&
													!data.isNurseHelp &&
													data.infos.takesToGo === 0 &&
													data.folders &&
													data.folders.length > 0 &&
													!data.folders[0].is_temp && (
														<>
															<MainButton
																type="button"
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.validateAndExportFolder(false, false, false, false, false);
																}}
																text={t("folderManager.validate")}
																disabled={
																	!(
																		data.infos.prescriptionStatus &&
																		data.infos.tubeStatus &&
																		formMotivationStatus &&
																		data.infos.aliquotStatus &&
																		formStatus &&
																		data.infos.questionAnswersSaved &&
																		!data.isDone &&
																		(!this.hasTubeWithResults(data.tubes) ||
																			(this.hasTubeWithResults(data.tubes) &&
																				data.infos.resultStatus.waiting.length === 0 &&
																				data.infos.resultStatus.result !== "")) &&
																		endoStatus &&
																		(!data.deposit || (data.deposit && this.getDepositErrors(data.deposit).length === 0)) &&
																		data.patient?.id !== +process.env.REACT_APP_USER_TO_CHANGE
																	)
																}
															/>
															<Confirm
																open={this.state.confirmEmailTelValidOpen}
																content={t("folderManager.confirmEmailTelNotValid")}
																cancelButton={t("folderManager.cancel")}
																confirmButton={t("folderManager.confirm")}
																onCancel={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({ confirmEmailTelValidOpen: false });
																}}
																onConfirm={(e) => {
																	if (e !== undefined) e.preventDefault();
																	if (!this.validateAndExportFolder(true, false, false, false, false))
																		this.setState({ confirmEmailTelValidOpen: false });
																}}
															/>
															<Confirm
																open={this.state.confirmPayment}
																content={t("folderManager.confirmPayment")}
																cancelButton={t("folderManager.cancel")}
																confirmButton={t("folderManager.confirmPay")}
																onCancel={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		confirmPayment: false,
																	});
																}}
																onConfirm={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		confirmPayment: false,
																	});
																	//if (e !== undefined) e.preventDefault();
																	//if (!this.validateAndExportFolder(true, true, false, false, false)) this.setState({ confirmPayment: false });
																}}
															/>
															<Confirm
																open={this.state.confirmYoungProche}
																content={
																	<div className="content">
																		<span>{t("folderManager.minorValidationFolder")}</span>
																		<br />
																	</div>
																}
																cancelButton={t("folderManager.cancel")}
																confirmButton={t("folderManager.confirm")}
																onCancel={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		confirmYoungProche: false,
																	});
																}}
																onConfirm={(e) => {
																	if (e !== undefined) e.preventDefault();
																	if (!this.validateAndExportFolder(true, true, true, false, false)) this.setState({ confirmYoungProche: false });
																}}
															/>
															<Confirm
																open={this.state.confirmProcheNoContact}
																content={
																	<div className="content">
																		<span>
																			Patient agé de moins de 18 ans lié à un tuteur sans téléphone ou adresse email. Êtes-vous sûr de vouloir valider
																			ce dossier ?
																		</span>
																		<br />
																	</div>
																}
																cancelButton="Annuler"
																confirmButton="Confirmer"
																onCancel={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		confirmProcheNoContact: false,
																	});
																}}
																onConfirm={(e) => {
																	if (e !== undefined) e.preventDefault();
																	if (!this.validateAndExportFolder(true, true, true, true, true)) this.setState({ confirmProcheNoContact: false });
																}}
															/>
															<Confirm
																open={this.state.confirmCNSInvalid}
																content={
																	<div className="content">
																		<span>{t("folderManager.confirmCNSInvalid")}</span>
																		<br />
																	</div>
																}
																cancelButton={t("folderManager.cancel")}
																confirmButton={t("folderManager.confirm")}
																onCancel={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		confirmCNSInvalid: false,
																	});
																}}
																onConfirm={(e) => {
																	if (e !== undefined) e.preventDefault();
																	if (!this.validateAndExportFolder(true, true, true, true, true)) this.setState({ confirmCNSInvalid: false });
																}}
															/>
														</>
													)}

												{mode === "sample" && data.infos.waitButton && (
													<>
														<WaitButton
															type="button"
															text={t("folderManager.waitButton")}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																else this.openConfirmationModal("wait");
															}}
															disabled={!(data.infos.tubeStatus && formStatus && data.infos.questionAnswersSaved)}
														/>

														<Confirm
															open={this.state.confirmNurseWaitOpen}
															content={t("folderManager.confirmNurseWait")}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirm")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmNurseWaitOpen: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																this.validateFolders().then(() => {
																	this.setState({
																		confirmNurseValidOpen: false,
																	});
																});
															}}
														/>
													</>
												)}
												{this.state.userIsSecretary && !data.isDone && data.folders && data.folders.length > 0 && data.folders[0].is_express && (
													<>
														<MainButton
															type="button"
															text={"Valider"}
															onClick={async (e) => {
																if (e !== undefined) e.preventDefault();
																this.validateFolders()
																	.then(async () => {
																		if (data.prescriptions && data.prescriptions.length > 0 && data.prescriptions[0].safeplace_code)
																			this.props.terminateSafePlaceQR(
																				this.state.data.prescriptions[0].safeplace_code,
																				this.props.centers?.center?.id
																			);
																		this.props.setPreviousFolder(data.folders[0]?.family_link?.id ?? data.folders[0].id);
																		if (this.props.generalParameters.data.disableFolderSecondValidation)
																			await this.props.getGeslabExport(data.folders[0].id);
																	})
																	.catch((e) => console.log("Erreur lors de la validation du dossier => dossier non exporté", data.folders[0].id, e));
																this.setState({
																	backReturn: true,
																});
															}}
															disabled={
																!data.infos.prescriptionStatus ||
																!data.infos.questionAnswersSaved ||
																data.patient?.id === +process.env.REACT_APP_USER_TO_CHANGE ||
																(data.prescriptions &&
																	data.prescriptions.length > 0 &&
																	!data.prescriptions[0].no_prescriber &&
																	data.prescriptions[0].scans.length === 0)
															}
														/>
														<MainButton
															type="button"
															text="Retourner à la liste"
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	backReturn: true,
																});
															}}
														/>
													</>
												)}
												{!data.isNurseHelp && (mode === "edit" || (data.folders && data.folders.length > 0 && data.folders[0].is_temp)) && (
													<>
														{!data.folders[0].is_express && (
															<MainButton
																type="button"
																text={data.isDone ? "Retourner à la liste" : "Valider & Retourner à la liste"}
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	if (!this.hasMissingInformation(data, false, false, false, false, false)) {
																		//removed validateFolders() here NURSE-401

																		this.setState({
																			backReturn: true,
																		});
																	}
																}}
																disabled={!data.isDone && !data.infos.prescriptionStatus}
															/>
														)}
														<Confirm
															open={this.state.confirmEmailTelValidOpen}
															content={t("folderManager.returnEmailTelValidFolder")}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirm")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmEmailTelValidOpen: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																if (!this.hasMissingInformation(data, true, true, false, false, false)) {
																	this.setState({
																		confirmEmailTelValidOpen: false,
																		backReturn: true,
																	});
																}
															}}
														/>

														<Confirm
															open={this.state.confirmPayment}
															content={t("folderManager.confirmPayment")}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirmPay")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmPayment: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmPayment: false,
																});
																//if (e !== undefined) e.preventDefault();
																// if (!this.hasMissingInformation(data, true, false, false, false, false)) {
																// 	this.setState({
																// 		confirmPayment: false,
																// 		backReturn: true,
																// 	});
																// }
															}}
														/>
														<Confirm
															open={this.state.confirmYoungProche}
															content={<div className="content"> {t("folderManager.minorValidationFolder")}</div>}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirm")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmYoungProche: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																if (!this.hasMissingInformation(data, true, true, true, false, false)) {
																	this.setState({
																		confirmYoungProche: false,
																		backReturn: true,
																	});
																}
															}}
														/>

														<Confirm
															open={this.state.confirmCNSInvalid}
															content={
																<div className="content">
																	<span>{t("folderManager.confirmCNSInvalid")}</span>
																	<br />
																</div>
															}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirm")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmCNSInvalid: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																if (!this.hasMissingInformation(data, true, true, true, true, true)) {
																	this.setState({
																		confirmCNSInvalid: false,
																		backReturn: true,
																	});
																}
															}}
														/>
													</>
												)}
												{data.isNurseHelp && (
													<>
														<MainButton
															type="button"
															text={t("folderManager.finishSupportBtn")}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	abortNurseHelp: false,
																});
																this.openCommentNurseHelp();
															}}
															disabled={(!data.isDone && !data.infos.prescriptionStatus) || this.isFastlinePatient}
														/>
														{this.state.data.folders[0].preregister && (
															<MainButton
																type="button"
																text={t("folderManager.incompleteFolderBtn")}
																icon="envelope outline"
																style={{
																	backgroundColor: "purple",
																	color: "white",
																}}
																onClick={(e) => {
																	if (e !== undefined) e.preventDefault();
																	this.setState({
																		abortNurseHelp: true,
																		cancelFolderWithFolderHelp: true,
																		incompleteFolder: true,
																	});
																	this.openCommentNurseHelp();
																}}
															/>
														)}
														<MainButton
															type="button"
															text={t("folderManager.cancelTelesecBtn")}
															style={{
																backgroundColor: "black",
																color: "white",
															}}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	abortNurseHelp: true,
																	cancelFolderWithFolderHelp: true,
																});
																this.openCommentNurseHelp();
															}}
														/>

														<MainButton
															type="button"
															text={t("folderManager.cancelSupportBtn")}
															style={{
																backgroundColor: "#a9000a",
																color: "white",
															}}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	abortNurseHelp: true,
																});
																this.openCommentNurseHelp();
															}}
														/>

														<CommentNurseHelpModal
															open={this.state.commentNurseHelpOpen}
															close={this.closeCommentNurseHelp}
															abort={this.state.abortNurseHelp}
															submit={this.submitCommentNurseHelp}
															folder={data.folders[0]}
															addComment={this.state.addCommentNurseHelp}
															cancel={this.state.cancelFolderWithFolderHelp}
															cancelResaonsOptions={this.props.folderHelp.cancelReasons}
															incompleteFolder={this.state.incompleteFolder}
														/>
													</>
												)}

												{data.isOpen && !data.isNurseHelp && (
													<>
														<SecondaryButton
															type="button"
															style={{
																backgroundColor: "#a9000a",
																color: "white",
															}}
															text={t("folderManager.cancelFolder")}
															onClick={this.openConfirmCancelFolder}
														/>

														<CancelFolderModal
															open={this.state.confirmCancelFolderOpen}
															close={this.closeConfirmCancelFolder}
															submit={this.submitConfirmCancelFolder}
														/>
													</>
												)}

												{mode !== "edit" && !data.isNurseHelp && data.folders && data.folders.length > 0 && !data.folders[0].is_temp && (
													<>
														<SecondaryButton
															type="button"
															text={t("folderManager.backToList")}
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																if (role === "NURSE" && !data.isDone)
																	this.setState({
																		confirmNurseQuitOpen: true,
																	});
																else {
																	this.setState({
																		backReturn: true,
																	});
																}
															}}
														/>

														<Confirm
															open={this.state.confirmNurseQuitOpen}
															content={t("folderManager.confirmNurseQuit")}
															cancelButton={t("folderManager.cancel")}
															confirmButton={t("folderManager.confirm")}
															onCancel={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmNurseQuitOpen: false,
																});
															}}
															onConfirm={(e) => {
																if (e !== undefined) e.preventDefault();
																this.setState({
																	confirmNurseQuitOpen: false,
																	backReturn: true,
																});
															}}
														/>
													</>
												)}
											</>
										)}
										{mode === "validate" && (
											<>
												{!data.isDone && (
													<MainButton
														text={t("folderManager.validateAndNext")}
														style={{ float: "right" }}
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															// noinspection JSIgnoredPromiseFromCall
															this.validatePrescriptionAndNext();
														}}
														disabled={!data.infos.prescriptionStatus}
													/>
												)}

												{!data.folders[0].validation_paused && !data.isDone && (
													<MainButton
														text={t("folderManager.pauseAndNext")}
														style={{ float: "right" }}
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.openValidationPausedReasonModal();
															// this.pauseFolderValidationAndNext();
														}}
													/>
												)}
												<SecondaryButton
													type="button"
													style={{ float: "left" }}
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();
														this.setState({ backReturn: true });
													}}
													text={t("folderManager.mainMenu")}
												/>
											</>
										)}
									</Grid.Column>
								</Grid.Row>
							</Grid>
							{!isThemeHospital && (
								<FolderSection
									data={data}
									mode={mode}
									isUrgent={isUrgent}
									isMobile={isMobile}
									t={t}
									role={role}
									costs={costs}
									folderManager={folderManager}
									blueCardColor={this.blueCardColor}
									openInvoicesModal={this.openInvoicesModal}
									updateCommentAndPostit={this.props.updateCommentAndPostit}
									isPaymentEnabled={this.isPaymentEnabled}
									isNotPaid={this.isNotPaid}
									amoutAlreadyPaid={this.amoutAlreadyPaid}
									openPaymentOptionsModal={this.openPaymentOptionsModal}
									paymentOptionsModal={this.state.paymentOptionsModal}
									paymentOptionsModalLoading={this.state.paymentOptionsModalLoading}
									getPaymentsBySource={this.getPaymentsBySource}
									amountToPay={this.amountToPay}
									getPaymentPartition={this.getPaymentPartition}
									addPayment={this.props.addPayment}
									folderPaymentCancel={this.props.folderPaymentCancel}
									folderIsPaid={this.props.folderIsPaid}
									analysisLibraryCosts={this.props.analysisLibrary.costs}
									invoices={this.props.patients?.invoices.length > 0 ? this.props.patients?.invoices?.filter((invoice) => invoice.amount > 0) : []}
									showDeposit={this.state.showDeposit}
									setShowDeposit={this.setShowDeposit}
									removeDeposit={this.props.removeDeposit}
									setActiveTabIndex={this.setActiveTabIndex}
									folderPaymentRef={this.props.folderPaymentRef}
								/>
							)}
							<PatientSection
								data={data}
								mode={mode}
								isMobile={isMobile}
								t={t}
								generalParameters={generalParameters}
								userIsSecretary={userIsSecretary}
								patientAddress={patientAddress}
								openContactModal={this.openContactModal}
								openEditPatient={this.openEditPatient}
								openSidebar={this.props.openSidebar}
								editPatient={this.editPatient}
								hideSidebar={this.props.hideSidebar}
								dualScreen={this.props.dualScreen}
								openGranteeModal={this.openGranteeModal}
								submitChangePatientModal={this.submitChangePatientModal}
								newPatient={this.newPatient}
								mysecuCheck={this.props.prescriptions.mysecuCheck}
								dkvCheck={this.props.patients.dkvStatus}
								dkvSyncing={this.props.patients.dkvSyncing}
								isThemeHospital={isThemeHospital}
								getMpiPatientByMatricule={this.props.getMpiPatientByMatricule}
							/>

							{!isThemeHospital && (
								<TelesecSection
									data={data}
									mode={mode}
									isMobile={isMobile}
									getTvSecStatus={this.getTvSecStatus}
									needHelp={this.props.user.session.needHelp}
									toggleNeedHelp={this.props.toggleNeedHelp}
									needHelpLoading={this.props.user.session.needHelpLoading}
									cleanScans={this.props.cleanScans}
									getScansForTVsecretariat={this.getScansForTVsecretariat}
									refreshCenterScans={this.props.refreshCenterScans}
									tvSecScans={this.props.prescriptions.tvSecScans}
									addScanOrdoToPrescription={this.addScanOrdoToPrescription}
									removeScanOrdo={this.props.removeScanOrdo}
									loadingScans={this.props.prescriptions.loadingScans}
									togglePreregisterWaitingFlag={this.props.togglePreregisterWaitingFlag}
									preregisterWaitingFlag={this.props.preregister?.current?.waitingFlag}
								/>
							)}
							<Grid style={{ margin: isMobile() ? "2rem -2rem" : "" }}>
								<Tab
									style={{ padding: 0, width: "100%" }}
									menu={{ vertical: isMobile() ? true : false, secondary: true, pointing: true, fluid: isMobile() ? true : false }}
									grid={isMobile() ? { paneWidth: 16, tabWidth: 16 } : {}}
									onTabChange={this.onTabChange}
									panes={getPanesData({
										t: t,
										prescriptionInfo: {
											status: data.infos.prescriptionStatus,
											errors: data.infos.prescriptionErrors,
											warnings: data.infos.prescriptionWarnings,
											othersWarnings: data.infos.prescriptionOthersWarnings,
										},
										disabled: data.isDone,
										data: data,
										mode: mode,
										role: role,
										generalParameters: generalParameters,
										folderManager: folderManager,
										isMobile: isMobile,
										folder: this.state.data.folders[0],
										dualScreen: this.props.dualScreen,
										openScanOrdo: this.state.openScanOrdo,
										userIsSecretary: role === "SECRETARY",
										sendFilesToDualScreen: sendFilesToDualScreen,
										sendFullScanListToDualScreen: this.sendFullScanListToDualScreen,
										openSidebar: this.props.openSidebar,
										editPrescription: this.editPrescription,
										openPrescriptionScanModal: this.openPrescriptionScanModal,
										deletePrescription: this.props.deletePrescription,
										hideSidebar: this.props.hideSidebar,
										openGranteeModal: this.openGranteeModal,
										validationLoading: this.state.validationLoading,
										validateScanPrescription: this.validateScanPrescription,
										validateQualityScanPrescription: this.validateQualityScanPrescription,
										unvalidateQualityScanPrescription: this.unvalidateQualityScanPrescription,
										deleteScanPrescription: this.deleteScanPrescription,
										setPrescriptionScanBarcode: this.props.setPrescriptionScanBarcode,
										openEditPatient: this.openEditPatient,
										tvSecScans: this.props.prescriptions.tvSecScans,
										getScansForTVsecretariat: this.getScansForTVsecretariat,
										refreshCenterScans: this.props.refreshCenterScans,
										cleanScans: this.props.cleanScans,
										createFolderHelpAndQuit: this.createFolderHelpAndQuit,
										updateScanPrescription: this.updateScanPrescription,
										analysisLibrary: this.props.analysisLibrary,
										loadAllAnalysesAndPacks: this.loadAllAnalysesAndPacks,
										postScanPrescription: this.postScanPrescription,
										getPrescriptionByBarcode: this.props.getPrescriptionByBarcode,
										editAnalyses: this.editAnalyses,
										getMatchingAnalyses: this.props.getMatchingAnalyses,
										bulkAnalysesPrescription: this.props.bulkAnalysesPrescription,
										groupByDocumentType: this.groupByDocumentType,
										documentTypes: this.props.documentTypes,
										getAllDocumentTypes: this.props.getAllDocumentTypes,
										getAllConsentRefusalReasons: this.props.getAllConsentRefusalReasons,
										consentRefusalReasons: this.props.consentRefusalReasons,
										postPhotoFolder: this.postPhotoFolder,
										center: this.props.user.session.center,
										addAutoScanLogs: this.props.addAutoScanLogs,
										connectedSecretariesList: this.props.folderHelp.connectedSecretariesList,
										loadingScans: this.props.prescriptions.loadingScans,
										removeScanOrdo: this.props.removeScanOrdo,
										useScanOrdo: this.props.useScanOrdo,
										getFPA: this.props.getFPA,
										openQRReaderPrescriptionModal: this.openQRReaderPrescriptionModal,
										openAddRepeatablePrescriptionModal: this.openAddRepeatablePrescriptionModal,
										addPrescription: this.addPrescription,
										formStatus: formStatus,
										formMotivationStatus: formMotivationStatus,
										questionAnswersSaved: data.infos.questionAnswersSaved,
										questionErrors: questionErrors,
										aliquotsErrors: data.infos.aliquotsErrors,
										aliquotStatus: data.infos.aliquotStatus,
										missingVolumeTubes: data.infos.missingVolumeTubes,
										resultStatus: data.infos.resultStatus,
										tubeStatus: data.infos.tubeStatus,
										tubeErrors: data.infos.tubeErrors,
										onQuestionsSubmit: this.onQuestionsSubmit,
										onMotivationsSubmit: this.onMotivationsSubmit,
										user: this.props.user,
										setFormStatus: this.setFormStatus,
										setQuestionErrors: this.setQuestionErrors,
										setMotivationsErrors: this.setMotivationsErrors,
										prevalidFolders: this.prevalidFolders,
										setFormikRef: this.setFormikRef,
										formikRef: this.state.formikRef,
										setQuestionsDataToUpdate: this.setQuestionsDataToUpdate,
										questionsDataToUpdate: this.state.questionsDataToUpdate,
										patchUntakenTube: this.patchUntakenTube,
										getAllTubeUntakenReasons: this.props.getAllTubeUntakenReasons,
										submitAddTubeModal: this.submitAddTubeModal,
										openDeleteNotPrescribedTubeConfirm: this.openDeleteNotPrescribedTubeConfirm,
										patchMultipleTubes: this.patchMultipleTubes,
										loadAddTubeModalData: this.loadAddTubeModalData,
										patchTubeSamplingTime: this.patchTubeSamplingTime,
										cancelReuseTube: this.cancelReuseTube,
										getReusableTubes: this.getReusableTubes,
										getAllTubeNatureReasons: this.props.getAllTubeNatureReasons,
										patchTubeNature: this.patchTubeNature,
										getMissingVolumeTubes: this.getMissingVolumeTubes,
										submitDeleteNotPrescribedTubeConfirm: this.submitDeleteNotPrescribedTubeConfirm,
										tubeReducer: this.props.tubes,
										saveSafeplaceResult: this.saveSafeplaceResult,
										activeTabIndex: this.state.activeTabIndex,
										logs: folderManager.logs,
										patchGeslabAlert: this.props.patchGeslabAlert,
										geslabAlert: data.folders[0].geslab_alert,
										identityModalOpen: this.state.identityModalOpen,
										toggleIdentityModal: this.toggleIdentityModal,
										getFolderLogs: this.props.getFolderLogs,
										checkIdentity: this.checkIdentity,
										openContactModal: this.openContactModal,
										motivationsSaved: data.infos.motivationsSaved,
										motivationsErrors: motivationsErrors,
										endoStatus: endoStatus,
										endoErrors: endoErrors,
										putEndoAnswers: this.putEndoAnswers,
										//refuseAnalysis: this.refuseAnalysis,
										saveDeposit: this.props.saveDeposit,
										motivations: this.props.analysisLibrary.motivations,
										showDeposit: this.state.showDeposit,
										depositPlaces: this.props.deposit.places,
										depositSamplers: this.props.deposit.samplers,
										depositErrors: this.getDepositErrors(data.deposit),
										isThemeHospital: isThemeHospital,
										checkAnalysis: this.props.checkAnalysis,
										toggleContact: this.props.toggleContact,
									})}
								/>
							</Grid>

							<Modal open={this.state.folderOpenedWarningOpen}>
								<Modal.Header>{t("folderManager.warning")}</Modal.Header>
								<Modal.Content>
									{t("folderManager.openFolderBy", {
										lastName: this.props.folderManager.folders[0]?.openedBy?.last_name,
										firstName: this.props.folderManager.folders[0]?.openedBy?.first_name,
									})}
								</Modal.Content>
								<Modal.Actions>
									<Button
										content={t("folderManager.ok")}
										onClick={() => {
											this.props.hideSidebar();
											this.setState({
												backReturn: true,
												unassignOpenedByOnExit: false,
												folderOpenedWarningOpen: false,
											});
										}}
									/>
								</Modal.Actions>
							</Modal>

							<QRReaderPrescriptionModal
								open={this.state.QRReaderPrescriptionModal}
								close={() => this.setState({ QRReaderPrescriptionModal: false })}
								submit={this.submitQRReaderPrescriptionModal}
								hasCameraAccess={this.state.hasCameraAccess}
							/>

							<AddRepeatablePrescriptionModal
								open={this.state.addRepeatablePrescriptionModal}
								close={this.closeAddRepeatablePrescriptionModal}
								submit={this.submitAddRepeatablePrescriptionModal}
								getMyLabDocuments={this.props.getMyLabDocuments}
							/>

							<ValidationPausedReasonModal
								reasons={validationPausedReasons.list}
								close={this.closeValidationPausedReasonModal}
								open={this.state.validationPausedReasonModalOpen}
								submit={this.pauseFolderValidationAndNext}
							/>

							<DispensationModal
								open={this.state.dispensationModal}
								close={this.closeDispensationModal}
								epn={this.state.prescriptionToDispense}
								folder={this.state.data}
							/>

							<Modal open={this.props.folderManager.barcodeWarningOpen}>
								<Modal.Header style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>{t("folderManager.barCodeUsed")}</Modal.Header>
								<Modal.Content style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>
									{t("folderManager.infoBarCodeUsed", { wrongBarCode: this.state.wrongBarCode })}
								</Modal.Content>
								<Modal.Actions style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>
									<Button color="blue" onClick={this.props.closeBarcodeWarningOpen}>
										{t("folderManager.ok")}
									</Button>
								</Modal.Actions>
							</Modal>
							<Modal open={this.props.folderManager.openedByWarningOpen}>
								<Modal.Header style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>{t("folderManager.warning")}</Modal.Header>
								<Modal.Content style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>{t("folderManager.openedFolder")}</Modal.Content>
								<Modal.Actions style={{ backgroundColor: "rgb(255,0,0,0.1)" }}>
									<Button
										color="blue"
										onClick={() => {
											this.props.closeOpenedByWarning();
											this.props.hideSidebar();
											this.setState({
												backReturn: true,
											});
										}}
									>
										{t("folderManager.ok")}
									</Button>
								</Modal.Actions>
							</Modal>

							<ContactModal
								open={this.state.contactModalOpen}
								close={this.closeContactModal}
								patient={data.patient}
								openEditPatient={() => {
									if (this.state.contactModalEditPatient) this.state.contactModalEditPatient();
									else
										this.props.openSidebar(
											<EditPatient
												patient={data.patient}
												prescriptions={data.folders[0].prescriptions}
												onSubmit={this.editPatient}
												hideSidebar={this.props.hideSidebar}
												disabled={data.isDone}
												dualScreen={this.props.dualScreen}
												hideOnSubmit={true}
											/>
										);
								}}
							/>
							{data.patient.grantees && data.patient.grantees.length > 0 && (
								<GranteeModal open={this.state.contactGranteeOpen} close={this.closeGranteeModal} patient={data.patient} />
							)}
						</div>
					</Ref>
				</Container>
			);
		}
	};
}

const mapStateToProps = (state) => {
	return {
		user: state.user,
		folderManager: state.folderManager,
		analysisLibrary: state.analysisLibrary,
		generalParameters: state.generalParameters,
		patients: state.patients,
		doctors: state.doctors,
		companies: state.companies,
		tubes: state.tubes,
		consentRefusalReasons: state.consentRefusalReasons,
		documentTypes: state.documentTypes,
		dualScreen: state.dualScreen,
		validationPausedReasons: state.validationPausedReasons,
		centers: state.centers,
		ws: state.ws,
		prescriptions: state.prescriptions,
		folderHelp: state.folderHelp,
		deposit: state.deposit,
		preregister: state.preregister,
	};
};

const mapDispatchToProps = {
	getFocusedFolders,
	setFocusedFolders,
	resetFocusedFolders,
	postPhotoFolder,
	deletePhotoFolder,
	patchPatientFromFolderManager,
	patchPrescription,
	postPrescription,
	deletePrescription,
	postScanPrescription,
	bulkAnalysesPrescription,
	getAnalysisLibrary,
	patchMultipleTubes,
	patchQuestionAnswer,
	deleteScanPrescription,
	updateScanPrescription,
	validateScanPrescription,
	validateQualityScanPrescription,
	unvalidateQualityScanPrescription,
	patchTube,
	validateFolders,
	validatePrescription,
	assignSecretary,
	unassignSecretary,
	getAllAnalysesPack,
	getDoctorExists,
	patchDoctor,
	postDoctor,
	getPrescriptionByBarcode,
	getFolderAnalysesCost,
	resetCosts,
	getMatchingAnalyses,
	getGeslabExport,
	setSampler,
	addNotPrescribedTube,
	deleteNotPrescribedTube,
	getRepeatablePresciptions,
	repeatPresciption,
	getFolderByCode,
	getAllTubeLibrary,
	getAllTubeAddedReasons,
	getAllTubeUntakenReasons,
	setPrescriptionScanBarcode,
	getFPA,
	changePatient,
	getMatchingPatient,
	patchPatient,
	postPatient,
	cancelFolder,
	getReusableTubes,
	getAllTubeNatureReasons,
	getMissingVolumeTubes,
	updatePhotoFolder,
	getPatientDocuments,
	addPatientDocument,
	deletePatientDocument,
	postPatientMyLab,
	getAllConsentRefusalReasons,
	folderIsPaid,
	folderPaymentCancel,
	folderPaymentRef,
	unassignOpenedBy,
	assignOpenedBy,
	getAllDocumentTypes,
	getFolderLogs,
	addAutoScanLogs,
	sendFilesToDualScreen,
	getNextFolderToValidate,
	getNextFolderFuture,
	pauseFolderValidation,
	addPayment,
	getAllValidationPausedReasons,
	closeBarcodeWarningOpen,
	closeOpenedByWarning,
	updateCommentAndPostit,
	patchGeslabAlert,
	setFamilyLink,
	searchFoldersFamilyLink,
	setPreviousFolder,
	createFolderHelp,
	abortSupportFolderHelp,
	validateFolderHelp,
	doneFolderHelp,
	postComment,
	saveResultPrescription,
	cancelSafePlaceQR,
	terminateSafePlaceQR,
	cancelTab,
	sendPatientToDualScreen,
	getInvoicesForPatient,
	refreshCenterScans,
	cleanScans,
	useScanOrdo,
	removeScanOrdo,
	checkMySecu,
	cleanMySecuCheck,
	getSecretariesActive,
	getNeedHelp,
	toggleNeedHelp,
	postIdentityCheck,
	getMyLabDocuments,
	getFolderHelpCancelReasons,
	sendEmailIncompleteFolder,
	putEndoAnswers,
	saveDeposit,
	getDepositPlaces,
	getDepositSamplers,
	removeDeposit,
	checkDKVStatus,
	cleanDkvStatus,
	togglePreregisterWaitingFlag,
	getEPrescription,
	getMpiPatientByMatricule,
	checkAnalysis,
	toggleContact,
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(FolderManager)));
